"use client"

import React, { useState, useEffect, useRef, useImperativeHandle, useMemo, version } from 'react';

import DataTableListGenerica from '../DataTableListGenerica/DataTableListGenerica'
import DataTableGenerica from './DataTableGenerica'
import DataTableGenericaPreguntaFormato from './DataTableGenericaPreguntaFormato'
import DataTableListGenericaRaw from '../DataTableListGenerica/DataTableListGenericaRaw'
//import JoditEditor from 'jodit-react';
//import { Document, Page, pdfjs } from 'react-pdf';
//pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;


import dynamic from 'next/dynamic';

import { ColorPicker } from 'primereact/colorpicker';
import { Skeleton } from 'primereact/skeleton';
import { Inplace, InplaceDisplay, InplaceContent } from 'primereact/inplace';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import classNames from 'classnames';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { OverlayPanel } from 'primereact/overlaypanel';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';


import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { RadioButton } from "primereact/radiobutton";

import { InputOtp } from 'primereact/inputotp';
import ReCAPTCHA from "react-google-recaptcha";


import { Tag } from 'primereact/tag';
import { Chip } from 'primereact/chip';

import { GenericaSistemaService } from '../../service/GenericaSistemaService';
import AuthStorage from '../../storage/AuthStorage';
import { InputTextarea } from 'primereact/inputtextarea';
import { Editor } from 'primereact/editor';
import Link from 'next/link';
import { SelectButton } from 'primereact/selectbutton';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Panel } from 'primereact/panel';

import Document from './Document';

import { PDFViewer } from '@embedpdf/react-pdf-viewer';
// esto es para embebedpdf

import { createPluginRegistration } from '@embedpdf/core';
import { EmbedPDF } from '@embedpdf/core/react';
import { usePdfiumEngine } from '@embedpdf/engines/react';

// Import the essential plugins
import { Viewport, ViewportPluginPackage } from '@embedpdf/plugin-viewport/react';
import { Scroller, ScrollPluginPackage } from '@embedpdf/plugin-scroll/react';
import { DocumentContent, DocumentManagerPluginPackage, } from '@embedpdf/plugin-document-manager/react';
import { RenderLayer, RenderPluginPackage } from '@embedpdf/plugin-render/react';



// ----------

import lodash from "lodash";

import { htmlToText } from "html-to-text";
import wordsCount from 'words-count';

import crypto from "crypto-js";
import "./FormularioGenerico.css";

export const PDFBase64Viewer = (props) => {

    const { engine, isLoading } = usePdfiumEngine();
    const genericaSistemaService = new GenericaSistemaService();

    const plugins = [
        createPluginRegistration(DocumentManagerPluginPackage, {
            initialDocuments: [{ url: "https://snippet.embedpdf.com/ebook.pdf" }],
        }),
        ,
        createPluginRegistration(ViewportPluginPackage),
        createPluginRegistration(ScrollPluginPackage),
        createPluginRegistration(RenderPluginPackage),
        // Agrega ViewportPluginPackage, ScrollPluginPackage, etc.
    ];

    console.log("PDFBase64Viewer,", props.url, engine, isLoading);

    if (isLoading) return <p>Cargando motor...</p>;

    return (
        <div style={{ height: '500px' }}>
            <EmbedPDF engine={engine} plugins={plugins}>
                {({ activeDocumentId }) =>
                    activeDocumentId && (
                        <DocumentContent documentId={activeDocumentId}>
                            {({ isLoaded }) =>
                                isLoaded && (
                                    <Viewport
                                        documentId={activeDocumentId}
                                        style={{
                                            backgroundColor: '#f1f3f5',
                                        }}
                                    >
                                        <Scroller
                                            documentId={activeDocumentId}
                                            renderPage={({ width, height, pageIndex }) => (
                                                <div style={{ width, height }}>
                                                    {/* The RenderLayer is responsible for drawing the page */}
                                                    <RenderLayer
                                                        documentId={activeDocumentId}
                                                        pageIndex={pageIndex}
                                                    />
                                                </div>
                                            )}
                                        />
                                    </Viewport>
                                )
                            }
                        </DocumentContent>
                    )
                }
            </EmbedPDF>
        </div>
    );
};


const JoditEditor = dynamic(() => import('jodit-react'), {
    ssr: false,
    loading: () => <p>Cargando editor...</p>
});


const FormularioCalculadoraCredito = React.forwardRef((props, ref) => {


    const { engine, isLoading } = usePdfiumEngine();

    const plugins = [
        createPluginRegistration(DocumentManagerPluginPackage, {
            initialDocuments: [{ url: "https://snippet.embedpdf.com/ebook.pdf" }],
        }),
        ,
        createPluginRegistration(ViewportPluginPackage),
        createPluginRegistration(ScrollPluginPackage),
        createPluginRegistration(RenderPluginPackage),
        // Agrega ViewportPluginPackage, ScrollPluginPackage, etc.
    ];


    console.log("FormularioGenerico, ");

    const utilizaDialog = props.utilizaDialog !== undefined ? props.utilizaDialog : true;

    const authStorage = new AuthStorage(window.location.pathname);
    const userDetails = authStorage.GetCurrentUser();
    const { userName, idEmpresa, idioma, sessionGUID } = userDetails;

    const genericaSistemaService = new GenericaSistemaService();

    const etiquetasModulo = props.etiquetasModulo;
    //const selectedTipoGenerica = props.selectedTipoGenerica;

    const [metadataGenericaSistema, setMetadataGenericaSistema] = useState([]);

    const [metadataGenericaSistemaTgOperaciones, setMetadataGenericaSistemaTgOperaciones] = useState([]);

    //const [modoEdicion, setModoEdicion] = useState(false);
    const [tgPreguntaReferenciada, setTgPreguntaReferenciada] = useState("BAS_REFERENCIA-REF_FMT_VSTA_RESPUESTA_REFERENCIADA_ITEM");

    const metadataGenericaSistemaForm = props.metadataGenericaSistemaForm;

    const [selectedColumns, setSelectedColumns] = useState([]);
    const [optionsSelectButton, setOptionsSelectButton] = useState(undefined);
    const genericaSistemaDialog = props.genericaSistemaDialog;

    const [selectedTipoGenericaConfirmacionOpt, setSelectedTipoGenericaConfirmacionOpt] = useState(undefined);
    const [genericaSistemaConfirmacionOpt, setGenericaSistemaConfirmacionOpt] = useState({});
    const [metadataGenericaSistemaConfirmacionOpt, setMetadataGenericaSistemaConfirmacionOpt] = useState([]);

    const requiereConfirmacionOPT = true; //props.requiereConfirmacionOPT;
    const [visibleConfirm, setVisibleConfirm] = useState(false);
    const [esperandoConfirmacionOPT, setEsperandoConfirmacionOPT] = useState(false);



    const validarOptionsSelectButtonRef = useRef(false);
    const guardando = useRef(false);
    const [modoEdicion, setModoEdicion] = useState(true);

    const genericaSistemaDialogRef = useRef(null);
    const toast = useRef(null);

    const [loadingLazyData, setLoadingLazyData] = useState(false);
    const [creandoFormulario, setCreandoFormulario] = useState(false);
    const [comodin, setComodin] = useState(0);

    const [loadingData, setLoadingData] = useState(false);

    useImperativeHandle(ref, () => ({
        onEditarFormularioFactura: onEditarFormularioFactura,
        //otraAccion: () => { /* ... */ }
    }));


    const _ = lodash;

    let emptyGenericaSistemaInit = {
        idEmpresa: idEmpresa, id: 0, ctiTexto: "", uts: []
    };

    const [emptyGenericaSistema, setEmptyGenericaSistema] = useState(emptyGenericaSistemaInit);

    const refBtGuardarDialogFooter = useRef(undefined);

    const prevSelectedTipoGenericaRef = useRef(undefined);
    const clasificadorOperacionRef = useRef("PROD");
    const campoRespuestaFormatoDiligenciadoRef = useRef("intentoCalculadora");

    const lazyParamInit = {
        first: 0,
        rows: 1000,
        page: 0,
        sortField: null,
        sortOrder: null,
        iteracion: 0,
        filters: {
            //'ctiTexto': { value: '', matchMode: FilterMatchMode.CONTAINS },
        }
    };

    const [guidIntento, setGuidIntento] = useState(window.crypto.randomUUID());

    const [lazyParams, setLazyParams] = useState(undefined);
    const lazyParamsInitSelected = useRef(Object.assign({}, lazyParamInit));


    const [selectedTipoGenerica, setSelectedTipoGenerica] = useState(undefined);

    const [selectedTipoGenerica_FORMULARIO_GENERICO_INTENTO, setSelectedTipoGenerica_FORMULARIO_GENERICO_INTENTO] = useState(undefined);
    const [selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO, setSelectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO] = useState(undefined);
    const [selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE, setSelectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE] = useState(undefined);
    const [selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE, setSelectedTipoGenerica_FORMULARIO_GENERICO_DETALLE] = useState(undefined);
    const [selectedTipoGenerica_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA, setSelectedTipoGenerica_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA] = useState(undefined);

    const [camposAMostrar_FORMULARIO_GENERICO_INTENTO, setCamposAMostrar_FORMULARIO_GENERICO_INTENTO] = useState("");
    const [camposAMostrar_FORMULARIO_GENERICO_CONSOLIDADO, setCamposAMostrar_FORMULARIO_GENERICO_CONSOLIDADO] = useState("");
    const [camposAMostrar_FORMULARIO_GENERICO_NOTAPADRE, setCamposAMostrar_FORMULARIO_GENERICO_NOTAPADRE] = useState("");
    const [camposAMostrar_FORMULARIO_GENERICO_DETALLE, setCamposAMostrar_FORMULARIO_GENERICO_DETALLE] = useState("");

    const [metadataGenericaSistemaForm_FORMULARIO_GENERICO_INTENTO, setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_INTENTO] = useState([]);
    const [metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO, setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO] = useState([]);
    const [metadataGenericaSistemaForm_FORMULARIO_GENERICO_NOTAPADRE, setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_NOTAPADRE] = useState([]);
    const [metadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE, setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE] = useState([]);

    const [metadataGenericaSistemaForm_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA, setMetadataGenericaSistemaForm_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA] = useState([]);

    const [genericasSistema_FORMULARIO_GENERICO_INTENTO, setGenericasSistema_FORMULARIO_GENERICO_INTENTO] = useState(null);
    const [genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO, setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO] = useState(null);
    const [genericasSistema_FORMULARIO_GENERICO_NOTAPADRE, setGenericasSistema_FORMULARIO_GENERICO_NOTAPADRE] = useState(null);
    const [genericasSistema_FORMULARIO_GENERICO_DETALLE, setGenericasSistema_FORMULARIO_GENERICO_DETALLE] = useState(null);

    const [genericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA, setGenericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA] = useState(null);

    const [genericaSistema, setGenericaSistema] = useState({ ...props.genericaSistema });

    const [urlPdfPreview, setUrlPdfPreview] = useState(undefined);

    const urlPdfPreviewRef = useRef(undefined);


    if ((props.selectedTipoGenerica !== undefined && selectedTipoGenerica === undefined) || props.selectedTipoGenerica.tg !== selectedTipoGenerica.tg) {
        setSelectedTipoGenerica({ ...props.selectedTipoGenerica });
        urlPdfPreviewRef.current = undefined;
    }
    else {

        let newSelectedTipoGenerica = undefined;

        if (!_.isEqual(props.selectedTipoGenerica.filtroUts, selectedTipoGenerica.filtroUts)) {
            //else if (props.selectedTipoGenerica.filtroUts !== selectedTipoGenerica.filtroUts) {
            newSelectedTipoGenerica = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version, filtroUts: { ...props.selectedTipoGenerica.filtroUts }, variableRestriccionExterna: { ...props.selectedTipoGenerica.variableRestriccionExterna }, };
            setSelectedTipoGenerica(newSelectedTipoGenerica);
            setGenericasSistema_FORMULARIO_GENERICO_INTENTO(null);
            setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO(null);
            setGenericasSistema_FORMULARIO_GENERICO_NOTAPADRE(null);
            setGenericasSistema_FORMULARIO_GENERICO_DETALLE(null);
            setGenericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA(null);
            urlPdfPreviewRef.current = undefined;
        }
        else if (props.selectedTipoGenerica.variableRestriccionExterna !== undefined
            && !_.isEqual(props.selectedTipoGenerica.variableRestriccionExterna, selectedTipoGenerica.variableRestriccionExterna)) {
            //else if (props.selectedTipoGenerica.filtroUts !== selectedTipoGenerica.filtroUts) {
            newSelectedTipoGenerica = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version, variableRestriccionExterna: { ...props.selectedTipoGenerica.variableRestriccionExterna }, };
            setSelectedTipoGenerica(newSelectedTipoGenerica);
            setGenericasSistema_FORMULARIO_GENERICO_INTENTO(null);
            setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO(null);
            setGenericasSistema_FORMULARIO_GENERICO_NOTAPADRE(null);
            setGenericasSistema_FORMULARIO_GENERICO_DETALLE(null);
            setGenericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA(null);
            urlPdfPreviewRef.current = undefined;
        }
        else if (props.selectedTipoGenerica.version !== undefined && selectedTipoGenerica.version !== undefined && props.selectedTipoGenerica.version !== selectedTipoGenerica.version) {

            let newSelectedTipoGenerica2 = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version };
            setSelectedTipoGenerica(newSelectedTipoGenerica2);
            setGenericasSistema_FORMULARIO_GENERICO_INTENTO(null);
            setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO(null);
            setGenericasSistema_FORMULARIO_GENERICO_NOTAPADRE(null);
            setGenericasSistema_FORMULARIO_GENERICO_DETALLE(null);
            setGenericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA(null);
            urlPdfPreviewRef.current = undefined;
        }

    }

    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [editando, setEditando] = useState(false);

    //const [genericaSistema, setGenericaSistema] = useState(emptyGenericaSistemaInit); 


    ref = genericaSistemaDialogRef

    function GetTextoEtiqueta(etiqueta) {
        return (etiquetasModulo.filter(et => et.etiqueta === etiqueta).map(et => et.ctiTexto));
    }

    useEffect(() => {

        if (selectedTipoGenerica.tg === "BPM_VSTA_SOLICITUD_CD_INVITADO_VERIFICACION_PAGARE"
        ) {

            let prevselectedTipoGenerica = { ...selectedTipoGenerica }
            let isEmpty = _.isEqual({}, selectedTipoGenerica);

            if (prevSelectedTipoGenericaRef.current === undefined && selectedTipoGenerica !== undefined && !isEmpty) {
                LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
                prevselectedTipoGenerica["intentoMetadata"] = 0;
            }
            else if (prevSelectedTipoGenericaRef.current !== undefined && selectedTipoGenerica !== undefined && !isEmpty) {

                if (prevSelectedTipoGenericaRef.current.tg !== selectedTipoGenerica.tg) {
                    LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
                    prevselectedTipoGenerica["intentoMetadata"] = 0;
                }
                else if (metadataGenericaSistema.length === 0 && (prevSelectedTipoGenericaRef.current.intentoMetadata === undefined || prevSelectedTipoGenericaRef.current.intentoMetadata < 1)) {
                    LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
                    prevselectedTipoGenerica["intentoMetadata"] = prevSelectedTipoGenericaRef.current.intentoMetadata ? prevSelectedTipoGenericaRef.current.intentoMetadata + 1 : 1;
                }
                else {
                    //console.log("setLazyParams");
                    setLazyParams({ ...lazyParams });
                }

            }

            prevSelectedTipoGenericaRef.current = prevselectedTipoGenerica;

        }

    }, [selectedTipoGenerica])

    const LoadDatosGenerica = async (_tg, idEmpresa, idioma, userName) => {

        //lazyParamInit.filters = createHeaderGenerica([{ "campo": "" }]);

        if (selectedTipoGenerica.tg !== "") {

            if ((selectedTipoGenerica.operaciones === undefined || selectedTipoGenerica.operaciones.length === 0)) {

                //console.log("GetTipoGenericaSistemaByTg - Datatablegener, ", selectedTipoGenerica)
                genericaSistemaService.GetTipoGenericaSistemaByTg({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, selectedTipoGenerica.tg).then(data => {

                    let newSelectedTipoGenerica = data.data;

                    if (selectedTipoGenerica.filtroUts !== undefined) {
                        newSelectedTipoGenerica.filtroUts = { ...selectedTipoGenerica.filtroUts };
                        newSelectedTipoGenerica.ctiTextoFiltroUts = selectedTipoGenerica.ctiTextoFiltroUts
                    }
                    if (selectedTipoGenerica.variableRestriccionExterna !== undefined) {
                        newSelectedTipoGenerica.variableRestriccionExterna = { ...selectedTipoGenerica.variableRestriccionExterna };
                    }
                    else {
                        newSelectedTipoGenerica.variableRestriccionExterna = {};
                    }

                    if (selectedTipoGenerica.operacionesCampos == undefined || !_.isEqual(selectedTipoGenerica.operacionesCampos, data.data.operacionesCampos)) {
                        newSelectedTipoGenerica.operacionesCampos = [...data.data.operacionesCampos];
                    }
                    if (selectedTipoGenerica.version !== undefined) {
                        newSelectedTipoGenerica.version = selectedTipoGenerica.version;
                    }

                    setSelectedTipoGenerica(newSelectedTipoGenerica);

                });
            }

            //else{}
            //console.log("tu mae, ", selectedTipoGenerica, metadataGenericaSistema, (selectedTipoGenerica.operaciones !== undefined && metadataGenericaSistema.length === 0), );
            if (selectedTipoGenerica.operaciones !== undefined && metadataGenericaSistema.length === 0) {
                console.log("entro");
                //else if (metadataGenericaSistema.length === 0 && selectedTipoGenerica.operaciones !== undefined) {

                await genericaSistemaService.getMetadataGenericasConOperacionesDeTg(_tg, idEmpresa, idioma, userName).then(async data => {


                    let columnaIdentificadorOculta = "tg";
                    let prefijo = '000000';
                    let TamSufijo = 4;
                    /*data = data.sort(function (a, b) {
                        let a1 = a.tg + '-' + (prefijo + a.orden).substring((prefijo + a.orden).length - TamSufijo) + '-' + a.campoOrigen + '-' + a.tipoDato;
                        let b1 = a.tg + '-' + (prefijo + b.orden).substring((prefijo + b.orden).length - TamSufijo) + '-' + b.campoOrigen + '-' + b.tipoDato;
                        return a1 > b1 ? 1 : a1 < b1 ? -1 : 0;
                    });*/

                    data = data.map(x => ({ ...x, formRef: null, columnRef: null, mensajeError: "" }));

                    let _metadataGenericaSistemaTgOperaciones = [...data];
                    //let _metadataGenericaSistemaTgOperaciones = data.map(x => x);
                    //setMetadataGenericaSistemaTgOperaciones(_metadataGenericaSistemaTgOperaciones);

                    data = data.filter(col => col.tg === _tg);

                    let metadataImprimible = data.filter(col => col.ctiConfigurado >= 0 && col.esImprimible > 0);

                    let dataForm = metadataImprimible;
                    let dataRef = data.map(x => ({ campo: x.campo, tipoDato: x.tipoDato, tg: x.tg, columnFiltroRef: null }));

                    if (dataRef.length > 0) {

                        setSelectedColumns([]);
                        //setEmptyGenericaSistema(crearNewEmptyGenerica(dataForm));

                        //lazyParamInit.filters = createHeaderGenerica(dataForm);

                        //console.log("lazyParamInit, ", lazyParamInit);

                        setMetadataGenericaSistema(data);

                        /*
                        setMetadataGenericaSistemaRef([...dataRef]);
                        setMetadataGenericaFormulario([...dataForm]);
                        setMetadataGenericaFormularioFactura([...dataForm]);

                        setSelectedTipoGenericaFormulario({ ...selectedTipoGenerica });
                        setSelectedTipoGenericaFormularioFactura({ ...selectedTipoGenerica });

                        */

                        if (selectedTipoGenerica.operaciones) {
                            let _canEditRow = selectedTipoGenerica.operaciones === undefined ? false : selectedTipoGenerica.operaciones.some(x => x.tg === selectedTipoGenerica.tg && x.tipoOperacion === "EDIT_ROW");
                            //setCanEditRow( (props.canEditRow | true) && selectedTipoGenerica.operaciones === undefined ? false : selectedTipoGenerica.operaciones.some(x => x.tg === selectedTipoGenerica.tg && x.tipoOperacion === "EDIT_ROW"));
                        }

                        setMetadataGenericaSistemaTgOperaciones(_metadataGenericaSistemaTgOperaciones);

                        establecerTipoGenericasFORMULARIO_CALIFICACION(_metadataGenericaSistemaTgOperaciones, false, guidIntento);

                        lazyParamInit.filters = {};
                        let newLazyParamInit = Object.assign({}, lazyParamInit);
                        setLazyParams({ ...newLazyParamInit });
                        lazyParamsInitSelected.current = newLazyParamInit;

                    }

                    // 

                    if (requiereConfirmacionOPT && metadataGenericaSistemaConfirmacionOpt.length === 0) {

                        let props_selectedTipoGenericaConfirmacionOPT_tg = "BPM_VSTA_SOLICITUD_CD_INTENTO_VERIFICACION_PAGARE_CONFIRMACION_OPT";

                        genericaSistemaService.GetTipoGenericaSistemaByTg({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName,
                            props_selectedTipoGenericaConfirmacionOPT_tg).then(data => {

                                let newSelectedTipoGenericaConfirmacionOpt = data.data;

                                if (selectedTipoGenerica.filtroUts) {
                                    newSelectedTipoGenericaConfirmacionOpt.filtroUts = selectedTipoGenerica.filtroUts;
                                    newSelectedTipoGenericaConfirmacionOpt.ctiTextoFiltroUts = selectedTipoGenerica.ctiTextoFiltroUts
                                }
                                if (selectedTipoGenerica.version) {
                                    newSelectedTipoGenericaConfirmacionOpt.version = selectedTipoGenerica.version;
                                }

                                setSelectedTipoGenericaConfirmacionOpt(newSelectedTipoGenericaConfirmacionOpt);
                                setMetadataGenericaSistemaConfirmacionOpt(data.metadata);

                            });
                    }


                });





            }
        }

    }

    const establecerTipoGenericasFORMULARIO_CALIFICACION = async (_metadataGenericaSistemaTgOperaciones, editando, guidIntento) => {


        clasificadorOperacionRef.current = editando === true ? "TMP" : "PROD";
        campoRespuestaFormatoDiligenciadoRef.current = editando === true ? "intentoCalculadora" : "intentoCalculadora";

        let tipoTgRef = "FORMULARIO_GENERICO_INTENTO";

        let metadataTgOperacionTgRef = [];
        let operaciontgRef = {};
        let newSelectedTipoGenericaTgRef = {};

        let newFiltroUts = { ...selectedTipoGenerica.filtroUts };

        if (editando) {
            newFiltroUts['uuidintento'] = guidIntento;
        }


        for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
            operaciontgRef = selectedTipoGenerica.operaciones[i];
            if (operaciontgRef.seccion === tipoTgRef && operaciontgRef.tipoOperacion === "DATASET_FORMULARIO"
                && operaciontgRef.clasificador === clasificadorOperacionRef.current
            )//)
                break;
        }

        //metadataTgOperacionTgRef = metadataGenericaSistemaTgOperaciones.filter(x => x.tg === operaciontgRef.tgRef && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0));

        var guid = window.crypto.randomUUID();

        newSelectedTipoGenericaTgRef = {
            tg: operaciontgRef.tgRef,
            cti: operaciontgRef.ctitgRef,
            ctiTexto: operaciontgRef.ctiTextotgRef,
            orden: operaciontgRef.ordentgRef,
            cgCampo: operaciontgRef.cgCampotgRef,
            operaciones: undefined,
            version: guid,
            variableRestriccionExterna: { ...selectedTipoGenerica.variableRestriccionExterna },
            filtroUts: { ...newFiltroUts },
            ctiTextoFiltroUts: selectedTipoGenerica.ctiTextoFiltroUts,

        }

        let newitemFORMULARIO_GENERICO_INTENTO = { ...newSelectedTipoGenericaTgRef };

        //-------------
        tipoTgRef = "FORMULARIO_GENERICO_CONSOLIDADO";
        metadataTgOperacionTgRef = [];
        operaciontgRef = {};
        newSelectedTipoGenericaTgRef = {};

        for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
            operaciontgRef = selectedTipoGenerica.operaciones[i];
            if (operaciontgRef.seccion === tipoTgRef && operaciontgRef.tipoOperacion === "DATASET_FORMULARIO"
                && operaciontgRef.clasificador === clasificadorOperacionRef.current
            )//&& operaciontgRef.tipoOperacion === "EDIT")
                break;
        }

        //metadataTgOperacionTgRef = metadataGenericaSistemaTgOperaciones.filter(x => x.tg === operaciontgRef.tgRef && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0));

        newSelectedTipoGenericaTgRef = {
            tg: operaciontgRef.tgRef,
            cti: operaciontgRef.ctitgRef,
            ctiTexto: operaciontgRef.ctiTextotgRef,
            orden: operaciontgRef.ordentgRef,
            cgCampo: operaciontgRef.cgCampotgRef,
            operaciones: undefined,
            version: guid,
            variableRestriccionExterna: { ...selectedTipoGenerica.variableRestriccionExterna },
            filtroUts: { ...newFiltroUts },
            ctiTextoFiltroUts: selectedTipoGenerica.ctiTextoFiltroUts,

        }


        let newitemFORMULARIO_GENERICO_CONSOLIDADO = { ...newSelectedTipoGenericaTgRef };


        //-------------
        tipoTgRef = "FORMULARIO_GENERICO_NOTAPADRE";
        metadataTgOperacionTgRef = [];
        operaciontgRef = {};
        newSelectedTipoGenericaTgRef = {};

        for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
            operaciontgRef = selectedTipoGenerica.operaciones[i];
            if (operaciontgRef.seccion === tipoTgRef && operaciontgRef.tipoOperacion === "DATASET_FORMULARIO"
                && operaciontgRef.clasificador === clasificadorOperacionRef.current
            )//&& operaciontgRef.tipoOperacion === "EDIT")
                break;
        }

        //metadataTgOperacionTgRef = metadataGenericaSistemaTgOperaciones.filter(x => x.tg === operaciontgRef.tgRef && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0));

        newSelectedTipoGenericaTgRef = {
            tg: operaciontgRef.tgRef,
            cti: operaciontgRef.ctitgRef,
            ctiTexto: operaciontgRef.ctiTextotgRef,
            orden: operaciontgRef.ordentgRef,
            cgCampo: operaciontgRef.cgCampotgRef,
            operaciones: undefined,
            version: guid,
            variableRestriccionExterna: { ...selectedTipoGenerica.variableRestriccionExterna },
            filtroUts: { ...newFiltroUts },
            ctiTextoFiltroUts: selectedTipoGenerica.ctiTextoFiltroUts,

        }


        let newitemFORMULARIO_GENERICO_NOTAPADRE = { ...newSelectedTipoGenericaTgRef };

        //-------------
        tipoTgRef = "FORMULARIO_GENERICO_DETALLE";
        metadataTgOperacionTgRef = [];
        operaciontgRef = {};
        newSelectedTipoGenericaTgRef = {};

        for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
            operaciontgRef = selectedTipoGenerica.operaciones[i];
            if (operaciontgRef.seccion === tipoTgRef && operaciontgRef.tipoOperacion === "DATASET_FORMULARIO"
                && operaciontgRef.clasificador === clasificadorOperacionRef.current
            )//&& operaciontgRef.tipoOperacion === "EDIT")
                break;
        }

        newSelectedTipoGenericaTgRef = {
            tg: operaciontgRef.tgRef,
            cti: operaciontgRef.ctitgRef,
            ctiTexto: operaciontgRef.ctiTextotgRef,
            orden: operaciontgRef.ordentgRef,
            cgCampo: operaciontgRef.cgCampotgRef,
            operaciones: undefined,
            version: guid,
            variableRestriccionExterna: { ...selectedTipoGenerica.variableRestriccionExterna },
            filtroUts: { ...newFiltroUts },
            ctiTextoFiltroUts: selectedTipoGenerica.ctiTextoFiltroUts,

        }

        let newitemFORMULARIO_GENERICO_DETALLE = { ...newSelectedTipoGenericaTgRef };

        setSelectedTipoGenerica_FORMULARIO_GENERICO_INTENTO(newitemFORMULARIO_GENERICO_INTENTO);
        setSelectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO(newitemFORMULARIO_GENERICO_CONSOLIDADO);
        setSelectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE(newitemFORMULARIO_GENERICO_NOTAPADRE);
        setSelectedTipoGenerica_FORMULARIO_GENERICO_DETALLE(newitemFORMULARIO_GENERICO_DETALLE);


        setCamposAMostrar_FORMULARIO_GENERICO_INTENTO("guid,intentoCalificacion");

        let _camposAMostrar_FORMULARIO_GENERICO_CONSOLIDADO = "nota";
        let _camposAMostrar_FORMULARIO_GENERICO_NOTAPADRE = "nota";
        let _camposAMostrar_FORMULARIO_GENERICO_DETALLE = "nota";

        setCamposAMostrar_FORMULARIO_GENERICO_CONSOLIDADO(_camposAMostrar_FORMULARIO_GENERICO_CONSOLIDADO);

        if (selectedTipoGenerica.tg === "FMT_FORMATO-0") {
            setCamposAMostrar_FORMULARIO_GENERICO_NOTAPADRE("ctiTextoDesc");
            setCamposAMostrar_FORMULARIO_GENERICO_DETALLE("ctiTextoDescpregunta");
        }
        else {
            setCamposAMostrar_FORMULARIO_GENERICO_CONSOLIDADO("solicitud,modeloPagare,optDestino");
            setCamposAMostrar_FORMULARIO_GENERICO_NOTAPADRE("solicitud,modeloPagare,optDestino");
            setCamposAMostrar_FORMULARIO_GENERICO_DETALLE("solicitud,modeloPagare,optDestino");
        }

        setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_INTENTO(_metadataGenericaSistemaTgOperaciones.filter(x => x.tg === newitemFORMULARIO_GENERICO_INTENTO.tg && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0)));

        let _metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO = _metadataGenericaSistemaTgOperaciones.filter(x => x.tg === newitemFORMULARIO_GENERICO_CONSOLIDADO.tg && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0));
        let _metadataGenericaSistemaForm_FORMULARIO_GENERICO_NOTAPADRE = _metadataGenericaSistemaTgOperaciones.filter(x => x.tg === newitemFORMULARIO_GENERICO_NOTAPADRE.tg && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0));
        let _metadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE = _metadataGenericaSistemaTgOperaciones.filter(x => x.tg === newitemFORMULARIO_GENERICO_DETALLE.tg && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0));

        setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO(_metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO);
        setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_NOTAPADRE(_metadataGenericaSistemaForm_FORMULARIO_GENERICO_NOTAPADRE);
        setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE(_metadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE);

        let newSelectedColumns = [];
        newSelectedColumns = _metadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE.filter(col => (_camposAMostrar_FORMULARIO_GENERICO_DETALLE.includes(col.campo)));

        setSelectedColumns(newSelectedColumns);

        if (clasificadorOperacionRef.current === 'TMP') {

            if (newitemFORMULARIO_GENERICO_NOTAPADRE.operaciones === undefined || newitemFORMULARIO_GENERICO_NOTAPADRE.operaciones.length === 0) {

                //console.log("GetTipoGenericaSistemaByTg - Datatablegener, ", selectedTipoGenerica)
                genericaSistemaService.GetTipoGenericaSistemaByTg({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, newitemFORMULARIO_GENERICO_NOTAPADRE.tg).then(data => {

                    let newSelectedTipoGenericaNotaPadre = data.data;

                    if (newitemFORMULARIO_GENERICO_NOTAPADRE.filtroUts !== undefined) {
                        newSelectedTipoGenericaNotaPadre.filtroUts = { ...newitemFORMULARIO_GENERICO_NOTAPADRE.filtroUts };
                        newSelectedTipoGenericaNotaPadre.ctiTextoFiltroUts = newitemFORMULARIO_GENERICO_NOTAPADRE.ctiTextoFiltroUts
                    }
                    if (newitemFORMULARIO_GENERICO_NOTAPADRE.variableRestriccionExterna !== undefined) {
                        newSelectedTipoGenericaNotaPadre.variableRestriccionExterna = { ...newitemFORMULARIO_GENERICO_NOTAPADRE.variableRestriccionExterna };
                    }
                    else {
                        newSelectedTipoGenericaNotaPadre.variableRestriccionExterna = {};
                    }

                    if (newitemFORMULARIO_GENERICO_NOTAPADRE.operacionesCampos == undefined || !_.isEqual(newitemFORMULARIO_GENERICO_NOTAPADRE.operacionesCampos, data.data.operacionesCampos)) {
                        newSelectedTipoGenericaNotaPadre.operacionesCampos = [...data.data.operacionesCampos];
                    }
                    if (newitemFORMULARIO_GENERICO_NOTAPADRE.version !== undefined) {
                        newSelectedTipoGenericaNotaPadre.version = newitemFORMULARIO_GENERICO_NOTAPADRE.version;
                    }

                    setSelectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE(newSelectedTipoGenericaNotaPadre);

                });
            }

            if (newitemFORMULARIO_GENERICO_DETALLE.operaciones === undefined || newitemFORMULARIO_GENERICO_DETALLE.operaciones.length === 0) {

                //console.log("GetTipoGenericaSistemaByTg - Datatablegener, ", selectedTipoGenerica)
                genericaSistemaService.GetTipoGenericaSistemaByTg({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, newitemFORMULARIO_GENERICO_DETALLE.tg).then(data => {

                    let newSelectedTipoGenericaDetalle = data.data;

                    if (newitemFORMULARIO_GENERICO_DETALLE.filtroUts !== undefined) {
                        newSelectedTipoGenericaDetalle.filtroUts = { ...newitemFORMULARIO_GENERICO_DETALLE.filtroUts };
                        newSelectedTipoGenericaDetalle.ctiTextoFiltroUts = newitemFORMULARIO_GENERICO_DETALLE.ctiTextoFiltroUts
                    }
                    if (newitemFORMULARIO_GENERICO_DETALLE.variableRestriccionExterna !== undefined) {
                        newSelectedTipoGenericaDetalle.variableRestriccionExterna = { ...newitemFORMULARIO_GENERICO_DETALLE.variableRestriccionExterna };
                    }
                    else {
                        newSelectedTipoGenericaDetalle.variableRestriccionExterna = {};
                    }

                    if (newitemFORMULARIO_GENERICO_DETALLE.operacionesCampos == undefined || !_.isEqual(newitemFORMULARIO_GENERICO_DETALLE.operacionesCampos, data.data.operacionesCampos)) {
                        newSelectedTipoGenericaDetalle.operacionesCampos = [...data.data.operacionesCampos];
                    }
                    if (newitemFORMULARIO_GENERICO_DETALLE.version !== undefined) {
                        newSelectedTipoGenericaDetalle.version = newitemFORMULARIO_GENERICO_DETALLE.version;
                    }

                    setSelectedTipoGenerica_FORMULARIO_GENERICO_DETALLE(newSelectedTipoGenericaDetalle);

                });
            }

        }


        //let newtgRefSelectItem = undefined;
        //newtgRefSelectItem = selectedTipoGenerica.operaciones.find(x => x.tg === selectedTipoGenerica.tg && x.tipoOperacion === "FORMULARIO_LIST_ITEM");
        //if (newtgRefSelectItem !== undefined)
        //setTgSelectItem(newtgRefSelectItem.tgRef);


    }

    useEffect(() => {

        if (lazyParams !== undefined && selectedTipoGenerica !== undefined
            && selectedTipoGenerica_FORMULARIO_GENERICO_INTENTO !== undefined
            && selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO !== undefined
            && selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE !== undefined
            //&& selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE !== undefined
        ) {
            loadLazyData();
        }

    }, [lazyParams]) // eslint-disable-line react-hooks/exhaustive-deps

    const loadLazyData = () => {
        //setLoadingLazyData(true);

        //if (loadLazyTimeout) {
        //clearTimeout(loadLazyTimeout);
        //}

        let tg = selectedTipoGenerica.tg === undefined ? "" : selectedTipoGenerica.tg;

        let filtroUts = {};
        let _filtroUtsValido = true;
        let _mensajeFiltroUtsValido = "";

        if (selectedTipoGenerica.filtroUts !== undefined) {
            for (const campo in selectedTipoGenerica.filtroUts) {
                if (campo.includes("ctiTexto") === false) {
                    filtroUts[`${campo}`] = selectedTipoGenerica.filtroUts[campo];
                    if (selectedTipoGenerica.filtroUts[campo] === null || selectedTipoGenerica.filtroUts[campo] === undefined) {
                        _filtroUtsValido = false;
                        let campoInvalido = metadataGenericaSistema.find(x => x.tg === selectedTipoGenerica.tg && x.campo === campo);
                        _mensajeFiltroUtsValido = _mensajeFiltroUtsValido + ", " + campoInvalido.ctiTexto;
                    }

                }
            }
        }

        if (editando) {
            filtroUts['uuidintento'] = guidIntento;
        }

        //setFiltroUtsValido(_filtroUtsValido);

        if (!_filtroUtsValido) {

            _mensajeFiltroUtsValido = _mensajeFiltroUtsValido.substring(2, _mensajeFiltroUtsValido.length);

            //setMensajeFiltroUtsValido("Debe seleccionar los siguientes campos en las tablas de arriba -> " + _mensajeFiltroUtsValido);

            setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO([]);
            setGenericasSistema_FORMULARIO_GENERICO_NOTAPADRE([]);
            console.log("cambio");
            setGenericasSistema_FORMULARIO_GENERICO_DETALLE([]);
            setGenericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA([]);

            //setTotalRecords(0);
            setLoadingLazyData(false);
            //setComodin(prev => prev + 1);


        }
        else {
            let clasificadorOperacionTg = editando === true ? "TMP" : "PROD";

            genericaSistemaService.getGenericasSistemaDS(tg, { lazyEvent: JSON.stringify(lazyParams) }, idEmpresa, idioma, userName, filtroUts, clasificadorOperacionTg).then(data => {
                //setMetadataGenericaSistema(data.metadata);


                if (data.metadata.length > 0
                    //&& selectedTipoGenerica.tipoTabla == "10" 
                    //&&  ((metadataGenericaSistema.find(x => x.idTipoAtributo >= 999) === undefined) 
                    //&& (data.metadata.find(x => x.idTipoAtributo >= 999) !== undefined))
                ) {
                    //if ( selectedTipoGenerica.tipoTabla =="10" && data.metadata.length>0 && (( metadataGenericaSistema.length===0) || ( metadataGenericaSistema.length>0 && data.metadata[0].tg !== metadataGenericaSistema[0].tg )) ){

                    let dataRef = data.metadata.map(x => ({ campo: x.campo, tipoDato: x.tipoDato, tg: x.tg, columnFiltroRef: null }));

                    let _metadataGenericaSistemaTgOperaciones = data.metadata;
                    let newSelectedColumns = data.metadata;//metadataImprimible.filter(col => col.campo !== columnaIdentificadorOculta)
                    let dataForm = newSelectedColumns;

                    if (dataRef.length > 0) {

                        //setSelectedColumns([]);

                        setEmptyGenericaSistema(crearNewEmptyGenerica(dataForm));

                        lazyParamInit.filters = {};
                        //lazyParamInit.filters = createHeaderGenerica(dataForm);
                        let newLazyParamInit = Object.assign({}, lazyParamInit);
                        //console.log("lazyParamInit, ", lazyParamInit);

                        setMetadataGenericaSistema(data.metadata);

                        //setMetadataGenericaSistemaRef(dataRef);
                        //setMetadataGenericaFormulario(dataForm);
                        //setMetadataGenericaFormularioFactura(dataForm);

                        //setSelectedTipoGenericaFormulario(selectedTipoGenerica);
                        //setSelectedTipoGenericaFormularioFactura(selectedTipoGenerica);

                        //setLazyParams({ ...newLazyParamInit });
                        //lazyParamsInitSelected.current = newLazyParamInit;
                        //setSelectedColumns(newSelectedColumns);

                        //if (selectedTipoGenerica.operaciones)
                        //setCanEditRow(selectedTipoGenerica.operaciones === undefined ? false : selectedTipoGenerica.operaciones.some(x => x.tg === selectedTipoGenerica.tg && x.tipoOperacion === "EDIT_ROW"));

                        //setMetadataGenericaSistemaTgOperaciones(_metadataGenericaSistemaTgOperaciones);
                        //setGenericaFormulario(emptyGenericaSistema);
                        //setGenericaFormularioFactura(emptyGenericaSistema);

                    }
                }

                //console.table(data.data.filter(x => x.tg === selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE.tg));
                if (clasificadorOperacionTg === "TMP") {
                    let ddd = "::";
                }

                let _genericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA = data.data.filter(x => x.tg === "BAS_REFERENCIA-REF_FMT_VSTA_RESPUESTA_REFERENCIADA_ITEM");

                validarOptionsSelectButtonRef.current = _genericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA.length > 0;

                setGenericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA(_genericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA);


                setGenericasSistema_FORMULARIO_GENERICO_INTENTO(data.data.filter(x => x.tg === selectedTipoGenerica_FORMULARIO_GENERICO_INTENTO.tg));

                let _genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO = data.data.filter(x => x.tg === selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO.tg);
                setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO(_genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO);

                let _genericasSistema_FORMULARIO_GENERICO_NOTAPADRE = data.data.filter(x => x.tg === selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE.tg);
                setGenericasSistema_FORMULARIO_GENERICO_NOTAPADRE(_genericasSistema_FORMULARIO_GENERICO_NOTAPADRE);

                let _genericasSistema_FORMULARIO_GENERICO_DETALLE = data.data.filter(x => x.tg === selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE.tg);

                if (_genericasSistema_FORMULARIO_GENERICO_DETALLE.length > 0) {
                    _genericasSistema_FORMULARIO_GENERICO_DETALLE.forEach(g => {
                        g['formRef'] = null;
                        g.uts['valido'] = g.uts['valido'] ? g.uts['valido'] === true : false;
                        g.uts['ingresado'] = g.uts['ingresado'] ? g.uts['ingresado'] === true : false;
                    });
                }

                setGenericasSistema_FORMULARIO_GENERICO_DETALLE(_genericasSistema_FORMULARIO_GENERICO_DETALLE);

                //crealor de inmmediato
                //setGenericasSistema(data.data)
                //setTotalRecords(previo => previo < 0 ? data.totalRecord : data.totalRecord);
                setLoadingLazyData(false);

                if (data.data.length > 0) {
                    setIntentoCalculadora(prev => prev + 1);
                    //setComodin(prev => prev + 1);
                }


            });

        }

    }

    const [intentoCalculadora, setIntentoCalculadora] = useState(0);

    useEffect(() => {

        if (intentoCalculadora > 0 && editando === false) {
            onEditarFormularioFactura(null);
        }

    }, [intentoCalculadora])



    const crearNewEmptyGenerica = (metadata) => {

        let item = {}

        item['tg'] = selectedTipoGenerica.tg;
        item['id'] = 0;
        item['idEmpresa'] = idEmpresa;
        item['idioma'] = "ES";

        item['uts'] = {};

        metadata.forEach(x => {
            if (x.campo === "tg")
                item[`${x.campo}`] = x.tg;
            else {

                let newVal = "";
                if (selectedTipoGenerica.filtroUts !== undefined && Object.keys(selectedTipoGenerica.filtroUts).includes(x.campo)) {
                    newVal = selectedTipoGenerica.filtroUts[x.campo];

                }

                item['uts'] = { ...item['uts'], [`${x.campo}`]: newVal }
            }
        });

        console.log("item., ", item);

        return item;

    }

    const onBooleanChange = (e, campo) => {

        const val = (e.checked && e.checked) || false;

        let _genericaSistema = { ...genericaSistema };

        if (metadataGenericaSistemaForm.find(x => x.campo === campo))
            _genericaSistema['uts'][`${campo}`] = val;
        else
            _genericaSistema[`${campo}`] = val;

        setGenericaSistema(_genericaSistema);

    }

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    const onInputChange = (e, campo, reFsGenericaSistemaBase) => {

        console.log("onInputChange, ", e, campo);

        let genericaSistemaBase = genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO[0];
        let setterGenericaBase = setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO;
        let metadataGenericaSistema = metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO;
        let setterMetadataGenericaSistema = setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO;


        if (reFsGenericaSistemaBase !== undefined) {
            genericaSistemaBase = reFsGenericaSistemaBase.genericaSistemaBase;
            setterGenericaBase = reFsGenericaSistemaBase.setterGenericaBase;

            metadataGenericaSistema = reFsGenericaSistemaBase.metadataGenericaBase;
            setterMetadataGenericaSistema = reFsGenericaSistemaBase.setterMetadataGenericaBase;

        }

        const val = (e.target && e.target.value) || e.htmlValue || '';
        let _genericaSistema = { ...genericaSistemaBase };

        if (_genericaSistema['uts'][`${campo}`] !== val) {

            let newMetadataGenericaSistemaForm = [...metadataGenericaSistema];
            let metadata = undefined;
            let newMetada = undefined;

            for (let index in newMetadataGenericaSistemaForm) {
                metadata = newMetadataGenericaSistemaForm[index];
                if (metadata.campo === campo) {

                    _genericaSistema['uts'][`${campo}`] = val;
                    newMetada = generarValidadoresMetadata(metadata, val, genericaSistemaBase);
                    newMetada.formRef = metadata.formRef;
                    newMetadataGenericaSistemaForm[index] = newMetada;

                    setterGenericaBase(_genericaSistema);
                    break;

                }
                else { newMetada = metadata; }
                //newMetadataGenericaSistemaForm.push(newMetada);

            }

            setterMetadataGenericaSistema(newMetadataGenericaSistemaForm);

        }

    }

    const onInputNumberChange = (e, campo) => {
        const val = e.value || 0;

        let _genericaSistema = { ...genericaSistema };

        if (metadataGenericaSistemaForm.find(x => x.campo === campo))
            _genericaSistema['uts'][`${campo}`] = val;
        else
            _genericaSistema[`${campo}`] = val;

        setGenericaSistema(_genericaSistema);

    }

    /*
    useEffect(() => {
        if (genericaSistemaDialog && metadataGenericaSistemaForm.length > 0) {
            setTimeout(() => {
                
                let tieneFoco = false;
                for ( let i in metadataGenericaSistemaForm)
                  {

                    let primerCampo = metadataGenericaSistemaForm[i];
                    
                    switch (primerCampo.tipoDato) {
                        case "boolean": primerCampo.formRef.getElement().focus(); break;
                        case "date":  break;
                        case "ref":   break;
                        case "label":   break;
                        case "file":   break;
                        default:  if (primerCampo.formRef!== null){
                            primerCampo.formRef && primerCampo.formRef.inputRef ? primerCampo.formRef.inputRef.current.focus() : primerCampo.formRef.focus(); 
                            tieneFoco=true;
                            break;
                            }
                            else break;
                            
                    }

                    if (tieneFoco)
                        break;

                }

                
            }, 100);

        }

    }, [genericaSistemaDialog]);*/


    const generarCabeceraFormulario = () => {

        //let primerCampo = metadataGenericaSistema.filter(col => selectedColumns.some(sCol => sCol.campo === col.campo && col.ctiConfigurado >= 0 && col.esImprimible > 0))[0];

        //console.log("metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO, ", genericasSistema_FORMULARIO_GENERICO_NOTAPADRE);

        //return metadataGenericaSistemaForm.filter(col => selectedColumns.some(sCol => sCol.campo === col.campo && col.ctiConfigurado >= 0 && col.esImprimible > 0)).map((metadata, index, array)=>(

        let datoFormato = genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO[0];

        console.log("datoFormato, ", datoFormato);

        return (
            <div className="field">

                <span> {datoFormato.uts['ctiTexto']} </span>

                <div className="m-0" dangerouslySetInnerHTML={{ __html: datoFormato.uts['ctiTextoDescformato'] }} />
            </div>
        );

    }


    const headerTemplateSegmento = (options) => {
        const className = `${options.className} justify-content-space-between`;

        return (
            <div className={className}>
                <div className="flex align-items-center gap-2">
                    <span className="font-bold">Amy Elsner</span>
                </div>

            </div>
        );
    };

    const footerTemplateSegmento = (options) => {
        const className = `${options.className} flex flex-wrap align-items-center justify-content-between gap-3`;

        return (
            <div className={className}>
                <div className="flex align-items-center gap-2">
                    <Button icon="pi pi-user" rounded text></Button>
                    <Button icon="pi pi-bookmark" severity="secondary" rounded text></Button>
                </div>
                <span className="p-text-secondary">Updated 2 hours ago</span>
            </div>
        );
    };


    //const generarSegmentosFormularioGenericaSistemaSeleccionada = () => {
    const generarCamposFormularioGenericaSistemaSeleccionada = () => {

        //let primerCampo = metadataGenericaSistema.filter(col => selectedColumns.some(sCol => sCol.campo === col.campo && col.ctiConfigurado >= 0 && col.esImprimible > 0))[0];

        //console.log("metadataGenericaSistemaForm_FORMULARIO_CALIFICACION_CONSOLIDADO, ", selectedColumns);

        //return metadataGenericaSistemaForm.filter(col => selectedColumns.some(sCol => sCol.campo === col.campo && col.ctiConfigurado >= 0 && col.esImprimible > 0)).map((metadata, index, array)=>(




        var camposAMostrar = camposAMostrar_FORMULARIO_GENERICO_CONSOLIDADO.split(",");

        console.log("asdfasfaf", metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO
            .filter(x => x.tipoDato !== "label" && x.tipoDato !== "sequence" && x.esImprimible === true && x.esSoloLectura === false && (x.actualizableEnFormulario === true)));

        return metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO
            .filter(x => x.tipoDato !== "label" && x.tipoDato !== "sequence" && x.esImprimible === true && x.esSoloLectura === false && (x.actualizableEnFormulario === true))
            .filter(col => camposAMostrar.some(sCol => sCol === col.campo && col.ctiConfigurado >= 0 && col.actualizableEnFormulario > 0))  //selectedColumns
            //.filter(x => ( x.campo === "nivelCriterioRA") || (x.tipoDato !== "label" && x.tipoDato !== "sequence" && x.actualizableEnFormulario === true && x.esSoloLectura === false))
            .map((metadata, index, array) => {
                //return metadataGenericaSistemaForm.filter(x => x.tipoDato !== "label" && x.tipoDato !== "sequence" && x.actualizableEnFormulario === true && x.esSoloLectura === false).map((metadata, index, array) => {
                //return metadataGenericaSistemaForm.filter(x => x.tipoDato !== "label").map((metadata, index, array) => {

                if (metadata.tipoDato === "sequence" || (selectedTipoGenerica.filtroUts && Object.keys(selectedTipoGenerica.filtroUts).includes(metadata.campo))) {
                    return (<></>);

                }

                else if (metadata.formatoDato !== "previewPdf") {

                    return (<>
                        <div className="field">
                            <label htmlFor={metadata.campo}>{metadata.ctiTexto}</label>
                            {generarCabeceraCampo(metadata)}
                            {generarCampo(metadata)}
                            {generarMensajeValidacionCampo(metadata)}

                        </div>

                    </>);

                }

                // Esto se hace porque la previewPdf no debe tener campos escribibles.
                else {
                    return (<>
                        <div className="field">
                            <label htmlFor={metadata.campo}>{metadata.ctiTexto}</label>
                            {generarCabeceraCampo(metadata)}

                            {generarMensajeValidacionCampo(metadata)}

                        </div>

                    </>);
                }
            });

    }

    const generarCampo = (metadata, reFsGenericaSistemaBase) => {

        let genericaSistemaBase = genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO[0];
        let setterGenericaBase = setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO;
        let metadatagenericaSistemaBaseFormBase = metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO;
        let setterMetadataGenericaSistema = setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO;


        if (reFsGenericaSistemaBase !== undefined) {
            genericaSistemaBase = reFsGenericaSistemaBase.genericaSistemaBase;
            setterGenericaBase = reFsGenericaSistemaBase.setterGenericaBase;

            metadatagenericaSistemaBaseFormBase = reFsGenericaSistemaBase.metadataGenericaBase;
            setterMetadataGenericaSistema = reFsGenericaSistemaBase.setterMetadataGenericaBase;

        }

        let val = genericaSistemaBase['uts'][`${metadata.campo}`];

        let modeNumeric = "decimal";
        let minFractionDigits = 0;
        let maxFractionDigits = 0;

        let classNameInput = "w-full md:w-9 " + classNames({ 'p-invalid': !metadata.valido && metadata.ingresado });

        switch (metadata.tipoDato) {
            case "boolean":
                val = (val === undefined) ? false : ((typeof val === "boolean") ? val : val.toLowerCase() === "true");
                return (
                    <Checkbox id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`}
                        checked={val} ref={e => metadata.formRef = e}
                        onChange={(e) => onBooleanChange(e, metadata.campo, reFsGenericaSistemaBase)}
                        className={classNameInput} ></Checkbox>
                );
            case "int":

                if (metadata.formatoDato === "money") {
                    modeNumeric = "currency";
                    minFractionDigits = 0;
                    maxFractionDigits = 0;
                }

                return (<InputNumber id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`} mode={modeNumeric} value={val} ref={e => metadata.formRef = e}
                    onValueChange={(e) => onInputNumberChange(e, metadata.campo, reFsGenericaSistemaBase)}
                    className={classNameInput} min={metadata.valMin} max={metadata.valMax} showButtons />);

            case "double":

                if (metadata.formatoDato === "money") {
                    modeNumeric = "currency";
                    minFractionDigits = 0;
                    maxFractionDigits = 0;
                }


                return (<><InputNumber id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`} mode={modeNumeric} value={val} ref={e => metadata.formRef = e}
                    onValueChange={(e) => onInputNumberChange(e, metadata.campo, reFsGenericaSistemaBase)} className={classNameInput} min={metadata.valMin} max={metadata.valMax} minFractionDigits={minFractionDigits} maxFractionDigits={maxFractionDigits} locale="es-CO" showButtons />
                </>);
            case "money":
                return (<InputNumber id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`} mode="currency" value={val} ref={e => metadata.formRef = e}
                    onValueChange={(e) => onInputNumberChange(e, metadata.campo, reFsGenericaSistemaBase)} className={classNameInput} />);
            case "sequence": return (<InputNumber id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`} readOnly value={val} ref={e => metadata.formRef = e}
                onValueChange={(e) => onInputNumberChange(e, metadata.campo, reFsGenericaSistemaBase)} className={classNameInput} />);
            case "double": return (<InputNumber id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`} mode="decimal" value={val} ref={e => metadata.formRef = e}
                onValueChange={(e) => onInputNumberChange(e, metadata.campo, reFsGenericaSistemaBase)} className={classNameInput} />);
            case "text":

                return (

                    <div className={classNameInput}>
                        <JoditEditor
                            //translate='no' style={{ height: '40rem' }}
                            value={val} ref={e => metadata.formRef = e}

                            config={config}
                            tabIndex={1} // tabIndex of textarea
                            //onBlur={(newContent) => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                            onChange={(newContent) => { onInputTextChange(newContent, metadata.campo); return false; }}
                        />
                    </div>


                );

            case "text3": return (
                <Editor headerTemplate={headerTemplateEditor} style={{ height: '10rem' }} id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`}
                    value={val} ref={e => metadata.formRef = e}
                    onTextChange={(e) => { onInputTextChange(e, metadata.campo, reFsGenericaSistemaBase) }} className={classNameInput} />

            );

            case "text2": return (<InputTextarea id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`} value={val} ref={e => metadata.formRef = e} onChange={(e) => onInputChange(e, metadata.campo, reFsGenericaSistemaBase)}
                className={classNameInput} />);



            case "date":

                if (metadata.formatoDato == "date") {
                    return (<Calendar id={`fieldEdit${metadata.tg}-${metadata.campo}`} ref={e => metadata.formRef = e}
                        value={val}
                        dateFormat="dd/mm/yy"
                        aria-labelledby={`label${metadata.tg}-${metadata.campo}`}
                        className={classNameInput}
                        onChange={(e) => onCalendarChange(e, metadata.campo)}
                        required
                        showButtonBar
                        keepInvalid={true}
                        parseDateTime={(text) => parseDateTime(text, metadata)}
                        readOnlyInput={false}
                        showIcon
                    />);

                }
                else {
                    return (<Calendar id={`fieldEdit${metadata.tg}-${metadata.campo}`} ref={e => metadata.formRef = e}
                        value={val}
                        dateFormat="dd/mm/yy"
                        aria-labelledby={`label${metadata.tg}-${metadata.campo}`}
                        className={classNameInput}
                        onChange={(e) => onCalendarChange(e, metadata.campo, reFsGenericaSistemaBase)}
                        required
                        showButtonBar
                        showTime
                        hourFormat="12"
                        keepInvalid={true}
                        parseDateTime={(text) => parseDateTime(text, metadata)}
                        readOnlyInput={false}
                        showIcon
                    />);
                }


            case "date5":
                console.log("date, ", val);
                return (<Calendar id="buttondisplay"
                    value={val}
                    onChange={(e) => { onCalendarChange(e, metadata.campo) }}
                    dateFormat="dd/mm/yy"
                    ref={e => metadata.formRef = e}
                    showButtonBar
                    required
                    keepInvalid={true}
                    parseDateTime={parseDateTime}
                    readOnlyInput={false}
                    showIcon />
                );


            case "date2":

                return (<Calendar id={`fieldEdit${metadata.tg}-${metadata.campo}`} showButtonBar showTime readOnlyInput={false} hourFormat="12" showIcon dateFormat="dd/mm/yy" aria-labelledby={`label${metadata.tg}-${metadata.campo}`} value={val} ref={e => metadata.formRef = e} required
                    onChange={(e) => onCalendarChange(e, metadata.campo, reFsGenericaSistemaBase)} className={classNameInput} />);

            case "date2":
                return (<Calendar showButtonBar readOnlyInput={false} showIcon dateFormat="dd/mm/yy" id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`} value={val} ref={e => metadata.formRef = e} required
                    onChange={(e) => onCalendarChange(e, metadata.campo, reFsGenericaSistemaBase)} className={classNameInput} />);

            case "color": return (<ColorPicker onChange={(e) => onInputChange(e, metadata.campo, reFsGenericaSistemaBase)} id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`} value={val} ref={e => metadata.formRef = e} required className={classNameInput} />);

            case "ref":

                let valRef = genericaSistemaBase['uts'][`${"ctiTexto" + metadata.campo}`];
                let metadataRef = { ...metadata }

                valRef = htmlToText(valRef);

                //console.log("metadata, ", metadata, "genericaSistemaBase,", selectedTipoGenerica);

                let refTg = {
                    "tg": metadata.formatoDato, "cti": "TG-SYS-ACA_UNIDAD", "ctiTexto": metadata.ctiTexto,
                    variableRestriccionExterna: { ...selectedTipoGenerica.variableRestriccionExterna },
                };
                let filtroUtsDominioDato = metadata.filtroUtsDominioDato || '';

                if (filtroUtsDominioDato.includes("[[INTERNO_")) {

                    metadatagenericaSistemaBaseFormBase.forEach(x => {

                        let campoInterno = `[[INTERNO_${x.campo}]]`;
                        if (metadata.campo !== x.campo && filtroUtsDominioDato.includes(campoInterno)) {

                            let valInterno = genericaSistemaBase['uts'][x.campo] || '';
                            filtroUtsDominioDato = filtroUtsDominioDato.replace(campoInterno, `'${valInterno}'`);
                            //console.log("ref listado, ", refTg, valRef, filtroUtsDominioDato);

                        }

                    });

                }

                //console.log("metadataRef.camposFiltroRef, ", metadataRef.camposFiltroRef);

                /*if (metadata.dominioDato !== null && metadata.dominioDato !== "") {
                    refTg.tg = metadata.dominioDato;
                    evalValMin.includes("[[EXTERNO_")
                }*/


                return (<div className={"tipoCampoRef " + classNameInput}>


                    <Button id={`bt${metadata.campo}`} type="button" icon="pi pi-search" label={valRef ? valRef || val : 'Click para Seleccionar'}
                        onClick={(e) => showOverlayPanel(e, `${metadata.campo}`)} aria-haspopup aria-controls="overlay_panel"
                        className="w-full  dropdown-fake" />

                    <OverlayPanel ref={e => metadata.formRef = e} showCloseIcon style={{ width: '80%', 'margin-top': '2%', 'margin-left': '2%' }} className="overlaypanel-demo">
                        <DataTableListGenerica selectedTipoGenerica={refTg}
                            onSelectedItem={onSelectedItem} metadataRef={metadataRef} etiquetasModulo={etiquetasModulo}
                            filtroUtsDominioDato={filtroUtsDominioDato} genericaSistemaBaseRef={genericaSistemaBase}
                        ></DataTableListGenerica>
                    </OverlayPanel>
                </div>);

            case "multivalue":

                if (val !== undefined)
                    val = val.replace(" ", "");

                let valRefMultivalue = genericaSistemaBase['uts'][`${"ctiTexto" + metadata.campo}`];

                valRefMultivalue = htmlToText(valRefMultivalue);

                console.log("metadata, ", metadata, "genericaSistemaBase,", selectedTipoGenerica);

                let refTgMultivalue = {
                    "tg": metadata.formatoDato, "cti": "TG-SYS-ACA_UNIDAD", "ctiTexto": metadata.ctiTexto,
                    variableRestriccionExterna: { ...selectedTipoGenerica.variableRestriccionExterna },
                };
                let filtroUtsDominioDatoMultivalue = metadata.filtroUtsDominioDato || '';

                if (filtroUtsDominioDatoMultivalue.includes("[[INTERNO_")) {

                    metadatagenericaSistemaBaseFormBase.forEach(x => {

                        let campoInterno = `[[INTERNO_${x.campo}]]`;
                        if (metadata.campo !== x.campo && filtroUtsDominioDatoMultivalue.includes(campoInterno)) {

                            let valInterno = genericaSistemaBase['uts'][x.campo] || '';
                            filtroUtsDominioDatoMultivalue = filtroUtsDominioDatoMultivalue.replace(campoInterno, `'${valInterno}'`);
                            //console.log("ref listado, ", refTg, valRef, filtroUtsDominioDato);

                        }

                    });




                }

                /*if (metadata.dominioDato !== null && metadata.dominioDato !== "") {
                    refTg.tg = metadata.dominioDato;
                    evalValMin.includes("[[EXTERNO_")
                }*/


                return (<div ref={e => metadata.formRef = e} className={classNames({ 'fieldCustom p-invalid': !metadata.valido && metadata.ingresado })}>


                    <DataTableListGenerica selectionMode="multivalue" initialSelectedItemes={val} selectedTipoGenerica={refTgMultivalue}
                        onSelectedItemes={onSelectedItemes} metadataRef={metadata} etiquetasModulo={etiquetasModulo}
                        filtroUtsDominioDato={filtroUtsDominioDatoMultivalue} genericaSistemaBaseRef={genericaSistemaBase}
                    ></DataTableListGenerica>
                </div>);

            case "ref2":

                const valRef2 = genericaSistemaBase['uts'][`${"ctiTexto" + metadata.campo}`];
                let refTg2 = { "tg": metadata.formatoDato, "cti": "TG-SYS-ACA_UNIDAD", "ctiTexto": metadata.ctiTexto };
                /*if (metadata.dominioDato !== null && metadata.dominioDato !== "") {
                    refTg.tg = metadata.dominioDato;
                }*/

                return (<Inplace closable ref={e => metadata.formRef = e} style={{ width: '95%' }} className={classNames({ 'fieldCustom p-invalid': !metadata.valido && metadata.ingresado })} >
                    <InplaceDisplay>
                        {valRef2 || val} || 'Click para Seleccionar'
                    </InplaceDisplay>
                    <InplaceContent>
                        <DataTableListGenerica selectedTipoGenerica={refTg2} onSelectedItem={onSelectedItem} metadataRef={metadata} etiquetasModulo={etiquetasModulo}></DataTableListGenerica>
                    </InplaceContent>
                </Inplace>);

            case "refDep":

                const valRef3 = genericaSistemaBase['uts'][`${"ctiTexto" + metadata.campo}`];
                let refTg3 = { "tg": metadata.formatoDato, "cti": "TG-SYS-ACA_UNIDAD", "ctiTexto": metadata.ctiTexto };
                /*if (metadata.dominioDato !== null && metadata.dominioDato !== "") {
                    refTg.tg = metadata.dominioDato;
                }*/

                return (<div className={classNames({ 'fieldCustom p-invalid': !metadata.valido && metadata.ingresado })}>
                    <Button id={`bt${metadata.campo}`} type="button" icon="pi pi-search" label={valRef3 ? valRef3 || val : 'Click para Seleccionar'} ref={e => metadata.formRef = e} style={{ width: '30%', minWidth: '10rem' }} onClick={(e) => showOverlayPanel(e, `${metadata.campo}`)} aria-haspopup aria-controls="overlay_panel" className="select-product-button" />
                    <OverlayPanel ref={e => metadata.formRef = e} showCloseIcon style={{ width: '80%', 'margin-top': '5%', 'margin-left': '5%' }} className="overlaypanel-demo">
                        <DataTableListGenerica selectedTipoGenerica={refTg} onSelectedItem={onSelectedItem} metadataRef={metadata} etiquetasModulo={etiquetasModulo}></DataTableListGenerica>
                    </OverlayPanel>
                </div>);

            case "refDocument":


                if (genericaSistemaBase.id > -100) {

                    const valRefDoc = genericaSistemaBase['uts'][`${"guid" + metadata.campo}`];

                    let sequenceTgContenedor = "";

                    if (genericaSistemaBase['uts'][`${selectedTipoGenerica.cgCampo}`] !== undefined) {
                        sequenceTgContenedor = genericaSistemaBase['uts'][`${selectedTipoGenerica.cgCampo}`] + "";
                    }
                    else {
                        let guid = window.crypto.randomUUID();
                        console.log(guid);

                        sequenceTgContenedor = guid;

                    }

                    //console.log("sequenceTgContenedor, ", selectedTipoGenerica, "genericaSistemaBase, ", genericaSistemaBase);
                    //if (genericaSistemaBase.id>0){
                    return (
                        <div className={"w-full lg:w-9 " + classNames({ 'fieldCustom p-invalid': !metadata.valido && metadata.ingresado })}>
                            <div>
                                {(valRefDoc !== null && valRefDoc !== undefined && valRefDoc !== "") ? (<Link target="_blank" icon="pi pi-download" rel="noopener noreferrer" to={"file?guid=" + valRefDoc}>Adjunto</Link>) : <span>No hay archivos cargados</span>}
                            </div>

                            <Inplace closable ref={e => metadata.formRef = e} className="mt-3" style={{ width: '95%' }} >
                                <InplaceDisplay>
                                    Clic para Cargar
                                </InplaceDisplay>
                                <InplaceContent>

                                    <Document guidDocument={valRefDoc} tgRef={selectedTipoGenerica.tg} cgRef={sequenceTgContenedor} onDocumentChange={onDocumentChange} metadataRef={metadata} />

                                </InplaceContent>
                            </Inplace>
                        </div>

                    );

                }
                else { return (<span>Archivo no carga </span>) }

            case "captcha":
                return (
                    //<Captcha siteKey="6Le1RQEsAAAAAFHJRQA393Z4UoUzW31997qtvFuT" onResponse={(e) => { onInputChange({ "htmlValue": e.response.substring(0, 100), "origin": e }, metadata.campo, reFsGenericaSistemaBase) }} />

                    //<Captcha siteKey="6Le1RQEsAAAAAFHJRQA393Z4UoUzW31997qtvFuT" onResponse={(e) => { onInputChange({ "htmlValue": e.response.substring(0, 100), "origin": e }, metadata.campo, reFsGenericaSistemaBase) }} />
                    <ReCAPTCHA sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY} onChange={(value) => onInputChange({ "htmlValue": value.substring(0, 100), "origin": value }, metadata.campo, reFsGenericaSistemaBase)} // Save token to state
                    />

                );

            case "opt":
                return (

                    <>

                        <div className="flex flex-column align-items-center">
                            <p className="font-bold text-xl mb-2">Autentica con la clave de único uso (OPT)</p>
                            <p className="text-color-secondary block mb-5">Por favor ingresa el código enviado a tu correo o celular.</p>
                            <span>Si no lo ha recibido, por favor verifique en su celular o correo en los mensajes no deseados o bloqueados</span>
                            <InputOtp id={`inputOTP${metadata.tg}-${metadata.campo}`} value={val}
                                onChange={(e) => onInputChange({ "htmlValue": e.value, "origin": e.value }, metadata.campo, reFsGenericaSistemaBase)}
                                length={6} inputTemplate={customInput} style={{ gap: 0 }}
                                className={classNameInput}
                            />

                        </div>


                    </>


                );

            /*
             <div className="flex justify-content-between mt-5 align-self-stretch">
                            <Button label="Resend Code" link className="p-0"></Button>
                            <Button label="Submit Code"></Button>
                        </div>
            */




            default: return (
                <InputText id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`}
                    value={val} ref={e => metadata.formRef = e} required
                    onChange={(e) => onInputChange(e, metadata.campo, reFsGenericaSistemaBase)}
                    className={classNameInput}
                    minLength={metadata.valMin} maxLength={metadata.valMax} />);

        }


    }

    const customInput = ({ events, props }) => {
        return <><input {...events} {...props} type="text" className="custom-otp-input-sample" />
            {props['data-index'] === 2 && <div className="px-3">
                <i className="pi pi-minus" />
            </div>}
        </>
    };

    const valorMaximoDefaultPorTipoDato = (tipoDato) => {
        if (tipoDato === "text") {
            return 1000;
        }
        else if (tipoDato === "file") {
            return 1;
        }
        else
            return 50000;
    }

    const generarValidadoresMetadata = (metadataBase, val, comodinValidacionGeneral, _genericaSistemaBase) => {


        let metadata = { ...metadataBase };
        let genericaSistemaBase = _genericaSistemaBase || genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO[0];

        let ingresado = false;

        if (val === undefined && comodinValidacionGeneral !== undefined) {
            val = genericaSistemaBase.uts !== undefined ? genericaSistemaBase['uts'][`${metadataBase.campo}`] : undefined;
            ingresado = comodinValidacionGeneral || false;
        }
        else {
            ingresado = val !== undefined;
        }

        let valido = false;
        let evalValMin = "";
        let evalValMax = "";
        evalValMin = metadata.restriccionFormatoMin;
        evalValMax = metadata.restriccionFormatoMax;

        let valMin = undefined;
        let valMax = undefined;
        let valEval = undefined;

        if (metadata.tipoDato === "int" || metadata.tipoDato === "double" || metadata.tipoDato === "money") {

            if (selectedTipoGenerica.variableRestriccionExterna !== undefined
                && ((evalValMin !== null && evalValMin.includes("[[EXTERNO_")) || (evalValMax !== null && evalValMax.includes("[[EXTERNO_")))) {

                Object.keys((selectedTipoGenerica.variableRestriccionExterna)).forEach(variableExterna => {

                    if (evalValMin !== null && evalValMin.includes(variableExterna)) {
                        evalValMin = evalValMin.replace(variableExterna, selectedTipoGenerica.variableRestriccionExterna[variableExterna].valor);
                        //valMin = selectedTipoGenerica.variableRestriccionExterna[variableExterna].valor;
                    }

                    if (evalValMax !== null && evalValMax.includes(variableExterna)) {
                        evalValMax = evalValMax.replace(variableExterna, selectedTipoGenerica.variableRestriccionExterna[variableExterna].valor);
                        //valMax = selectedTipoGenerica.variableRestriccionExterna[variableExterna].valor;
                    }

                });

            }
            else if ((evalValMin !== null && evalValMin.includes("[[")) || (evalValMax !== null && evalValMax.includes("[["))) {

            }

            if (evalValMin !== null && !evalValMin.includes("[[")) {
                valMin = eval(evalValMin);
            }

            if (evalValMax !== null && !evalValMax.includes("[[")) {
                valMax = eval(evalValMax);
            }

            if (val !== undefined) {

                valEval = val;

                console.log("campo, ", metadata.campo, ", valEval number, ", metadata.esRequerido, valEval, valMin, valMax);

                valido = (!metadata.esRequerido || (metadata.esRequerido && valEval !== undefined));

                valido = valido && valMin !== undefined ? valido * valEval >= valMin : valido;
                valido = valido && valMax !== undefined ? valido * valEval <= valMax : valido;
            }

        }

        else if (metadata.tipoDato === "boolean") {
            valEval = val;
            valido = valEval === undefined || valEval === null ? false : true;
        }

        else if (metadata.tipoDato === "date") {
            valEval = val;
            valido = false;
            //if ()
            if (val instanceof Date) {
                valido = true;
            }
        }

        else { //if (metadata.tipoDato === "string" || metadata.tipoDato === "text") {


            valMin = eval(evalValMin);
            valMin = valMin !== undefined && valMin !== "" ? valMin : metadata.esRequerido ? 1 : 0;

            if (metadata.campo === "documento") {
                console.log("dfdfdfdfd", valMin, metadata);
            }


            valMax = eval(evalValMax);
            valMax = valMax !== undefined && valMax !== "" ? valMax : valorMaximoDefaultPorTipoDato(metadata.tipoDato);

            if (val !== undefined) {

                if (val === null)
                    val = "";

                valEval = val.toString();

                if (metadata.tipoDato === "text") {
                    valEval = wordsCount(htmlToText(val));
                }
                else {
                    valEval = valEval.length;
                }

                //console.log("Else campo, ", metadata.campo, metadata.esRequerido, " - ", metadata.tg, "val: ", val, "valEval: ", valEval, "valMin: ", valMin, "valMax:", valMax);

                valido = (!metadata.esRequerido || (metadata.esRequerido && valEval > 0));
                valido = valido && valMin !== undefined ? valido * valEval >= valMin : valido;
                valido = valido && valMax !== undefined ? valido * valEval <= valMax : valido;

                if (valido && metadata.formatoDato === "email") {
                    valido = validateEmail(val) !== null;
                }

            }
            else {
                valEval = 0;
                valido = (!metadata.esRequerido || (metadata.esRequerido && valEval > 0));
                valido = valido && valMin !== undefined ? valido * valEval >= valMin : valido;
                valido = valido && valMax !== undefined ? valido * valEval <= valMax : valido;

            }


        }

        metadata.valMin = valMin;
        metadata.valMax = valMax;

        metadata.error = "";
        metadata.valido = valido;
        metadata.ingresado = ingresado;
        metadata.valEval = valEval;

        //console.log("dfdfdfdfd", metadata.campo, valido, valEval, valMin, valMax, inicial, metadata);


        return metadata;

    }

    const onSelectedItem = async (e, metadataRef) => {

        console.log("onSelectedItem", e);

        let _genericasConsolidado = [];

        genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO.forEach(x => {
            let newGenericaDetalle = { ...x }
            newGenericaDetalle.formRef = x.formRef;
            _genericasConsolidado.push(newGenericaDetalle);
        });

        //let genericaDetalle = _genericasNotaPadre.find(x => x.uts["pregunta"] === metadataRef.referenciaRef);

        let _genericaSistema = _genericasConsolidado[0];

        let tieneAfectacionCtitextoRef = false;
        let tieneAfectacionVal = false;

        //let _genericaSistema = { ...genericaSistema };

        const val = e['uts'][`${metadataRef.refCampoTg}`] || '';

        if (1 === 1) {
            //if (_genericaSistema['uts'][`${metadataRef.campo}`] !== val) {

            let afectacionExtraSeleccionRef = "";
            let obj = {};

            afectacionExtraSeleccionRef = metadataRef.afectacionExtraSeleccionRef;

            if (afectacionExtraSeleccionRef !== undefined && afectacionExtraSeleccionRef !== "") {
                //afectacionExtraSeleccionRef = afectacionExtraSeleccionRef.replace(" ", "");
                let splitAfectaciones = afectacionExtraSeleccionRef.split("=>");
                if (splitAfectaciones.length == 2) {
                    splitAfectaciones[0] = splitAfectaciones[0].replace("(", "").replace(")", "");
                    splitAfectaciones[1] = splitAfectaciones[1].replace("(", "").replace(")", "");
                    let camposExpresionesOrigen = splitAfectaciones[0].split(",");
                    let camposDependientes = splitAfectaciones[1].split(",");
                    if (camposExpresionesOrigen.length === camposDependientes.length) {

                        let keysUtsGenericaSistema = Object.keys(_genericaSistema.uts);
                        let keysUtsE = Object.keys(e.uts);

                        for (let i = 0; i < camposDependientes.length; i++) {
                            //console.log("dfdfdfd, ", Object.keys(_genericaSistema).includes(camposDependientes[i]));
                            if (keysUtsGenericaSistema.includes(camposDependientes[i])) {

                                if (keysUtsE.includes(camposExpresionesOrigen[i])) {
                                    _genericaSistema.uts[camposDependientes[i]] = e.uts[camposExpresionesOrigen[i]];

                                    if (camposDependientes[i] === `ctiTexto${metadataRef.campo}`) {
                                        tieneAfectacionCtitextoRef = true;
                                    }

                                    if (camposDependientes[i] === metadataRef.campo) {
                                        tieneAfectacionVal = true;
                                    }

                                }
                                else {
                                    console.log("ExpresionesOrigen no soportado aún");
                                }

                            }
                        }

                    }
                }
            }

            const ValText = !tieneAfectacionCtitextoRef && Object.keys(e['uts']).includes(`ctiTexto${metadataRef.refCampoTg}`) ?
                e['uts'][`ctiTexto${metadataRef.refCampoTg}`] :
                tieneAfectacionCtitextoRef && metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO.some(x => x.campo === `ctiTexto${metadataRef.campo}`) ? _genericaSistema.uts[`ctiTexto${metadataRef.campo}`] : "";

            //----

            let newMetadataGenericaSistemaForm = [...metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO];
            let metadata = undefined;
            let newMetada = undefined;
            let valAnt = undefined;

            for (let index in newMetadataGenericaSistemaForm) {
                metadata = newMetadataGenericaSistemaForm[index];

                if (metadata.campo === metadataRef.campo) {

                    if (!tieneAfectacionCtitextoRef) {
                        _genericaSistema['uts'][`ctiTexto${metadataRef.campo}`] = ValText;
                    }

                    if (!tieneAfectacionVal) {
                        valAnt = _genericaSistema['uts'][`${metadataRef.campo}`];
                        _genericaSistema['uts'][`${metadataRef.campo}`] = val;
                        newMetada = generarValidadoresMetadata(metadata, val);

                        if (val !== valAnt) {
                            // aqui es para las campos disparadores
                            let dd = "";
                        }

                    }

                    newMetada = { ...metadata };

                    newMetada.formRef = metadata.formRef;
                    //newMetadataGenericaSistemaForm[index] = newMetada;

                    await genericaSistemaService.saveGenericaSistema(idEmpresa, idioma, userName, _genericaSistema).then(response => {

                        setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO([_genericaSistema]);

                        setLazyParams({ ...lazyParams });
                        //onSaveSuccessfullDataTableGenericaCalificacion([]);

                        console.log("metadata, ", metadata, ", metadataRef.formRef,", metadataRef.formRef);

                        if (metadataRef.formRef) {

                            if (metadataRef.formRef) {
                                metadataRef.formRef.hide();
                            }
                            else {
                                let formRef = metadataRef.formRef.getElement();
                                let botonClose = formRef.children[0].children[1];
                                if (botonClose.click)
                                    botonClose.click();
                            }

                            /*
                            if (metadataRef.formRef.getElement().close) {
                                metadataRef.formRef.getElement().close();
                            }
                            
                            else if (metadataRef.formRef.getElement().hide)
                                metadataRef.formRef.getElement().hide();*/
                        }


                    });

                    break;

                }
                else {
                    newMetada = metadata;
                }

            }

            //setMetadataGenericaSistemaForm(newMetadataGenericaSistemaForm);

        }
        else if (metadataRef.formRef) {

            if (metadataRef.formRef) {
                metadataRef.formRef.hide();
            }
            else {
                let formRef = metadataRef.formRef.getElement();
                let botonClose = formRef.children[0].children[1];
                if (botonClose.click)
                    botonClose.click();
            }

            /*
            if (metadataRef.formRef.getElement().close) {
                metadataRef.formRef.getElement().close();
            }
            
            else if (metadataRef.formRef.getElement().hide)
                metadataRef.formRef.getElement().hide();*/
        }


    }

    const onSelectedItem2 = (e, metadataRef) => {


        let _genericasNotaPadre = [];

        genericasSistema_FORMULARIO_GENERICO_NOTAPADRE.forEach(x => {
            let newGenericaDetalle = { ...x }
            newGenericaDetalle.formRef = x.formRef;
            _genericasNotaPadre.push(newGenericaDetalle);
        });

        //let genericaDetalle = _genericasNotaPadre.find(x => x.uts["pregunta"] === metadataRef.referenciaRef);

        let genericaDetalle = _genericasNotaPadre[0];

        if (genericaDetalle !== null) {

            const val = e['uts'][`${metadataRef.refCampoTg}`] || '';
            const ValText = Object.keys(e['uts']).includes(`ctiTexto${metadataRef.refCampoTg}`) ? e['uts'][`ctiTexto${metadataRef.refCampoTg}`] : Object.keys(e['uts']).includes(`ctiTexto`) ? e['uts'][`ctiTexto`] : "";

            console.log("dfdf", val, ValText);
            if (metadataGenericaSistemaForm_FORMULARIO_GENERICO_NOTAPADRE.find(x => x.campo === metadataRef.campo)) {

                genericaDetalle['uts'][`${metadataRef.campo}`] = val;
                genericaDetalle['uts'][`ctiTexto${metadataRef.campo}`] = ValText;
            }
            else
                genericaDetalle[`${metadataRef.campo}`] = val;

            console.log("metadataRef, ", val, ValText);
            setGenericasSistema_FORMULARIO_GENERICO_NOTAPADRE(_genericasNotaPadre);

            //let element = genericaDetalle.formRef.getElement();
            if (genericaDetalle.formRef) {

                if (genericaDetalle.formRef.close) {
                    genericaDetalle.formRef.close();
                }
                else if (genericaDetalle.formRef.hide)
                    genericaDetalle.formRef.hide();
            }

        }

    }




    const renderHeaderTemplateEditor = () => {
        return (
            <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
            </span>
        );
    }

    const headerTemplateEditor = renderHeaderTemplateEditor();

    const generarPregunta = (pregunta) => {


        let campoTipoDato = "tipoDato";
        let campoFormatoDato = "formatoDato";
        let campoValor = "valor";

        let tipoDato = pregunta['uts'][`${campoTipoDato}`] | "string";

        if (tipoDato === "string") {
            campoValor = "valor";
        }
        else if (tipoDato == "int" || tipoDato == "double" || tipoDato == "double") {
            campoValor = "valorNumber";
        }
        else if (tipoDato == "text") {
            campoValor = "valorTexto";
        }
        else if (tipoDato == "date") {
            campoValor = "valorDateTime";
        }
        else
            campoValor = "valor";

        let val = pregunta['uts'][`${campoValor}`];


        let refTg = { "tg": pregunta['uts'][`${campoFormatoDato}`], "cti": "TG-SYS-ACA_UNIDAD", "ctiTexto": pregunta.ctiTexto };

        const valRef = pregunta['uts'][`${"ctiTexto" + pregunta.campo}`];
        //pregunta['formRef']

        if (false) {
            //if (metadata.actualizableEnFormulario === false) {

            switch (pregunta['uts'][campoTipoDato]) {
                case "boolean":
                    val = (val === undefined) ? false : ((typeof val === "boolean") ? val : val.toLowerCase() === "true");
                    return (<Checkbox checked={val} ref={e => pregunta.formRef = e} ></Checkbox>);
                case "int": return (<InputNumber value={val} ref={e => pregunta.formRef = e} readOnly />);
                case "sequence": return (<InputNumber readOnly value={val} ref={e => pregunta.formRef = e} onValueChange={(e) => onInputNumberChange(e, pregunta.campo)} className={classNames({ 'p-invalid': !pregunta.uts['valido'] })} />);
                case "double": return (<InputNumber mode="decimal" value={val} ref={e => pregunta.formRef = e} readOnly />);
                case "text": return (<div className="m-0" ref={e => pregunta.formRef = e} dangerouslySetInnerHTML={{ __html: val }} />);
                case "text1": return (<InputTextarea value={val} ref={e => pregunta.formRef = e} onChange={(e) => onInputChange(e, pregunta.campo)} className={classNames({ 'p-invalid': !pregunta.uts['valido'] })} />);
                case "date": return (<Calendar showButtonBar yearNavigator={false} yearRange="2010:2030" showIcon dateFormat="dd/mm/yy" id={`bt${pregunta.id}`} value={val} ref={e => pregunta.formRef = e} required onChange={(e) => onInputChange(e, pregunta.campo)} className={classNames({ 'p-invalid': !pregunta.uts['valido'] })} />);
                case "date": return (<Calendar showButtonBar yearNavigator={false} yearRange="2010:2030" showIcon dateFormat="dd/mm/yy" id={`bt${pregunta.id}`} value={val} ref={e => pregunta.formRef = e} required onChange={(e) => onInputChange(e, pregunta.campo)} className={classNames({ 'p-invalid': !pregunta.uts['valido'] })} />);
                case "refDocument":


                    if (genericaSistema.id > -100) {

                        const valRefDoc = genericaSistema['uts'][`${"guid" + pregunta.campo}`];

                        let sequenceTgContenedor = "";

                        if (genericaSistema['uts'][`${selectedTipoGenerica.cgCampo}`] !== undefined) {
                            sequenceTgContenedor = genericaSistema['uts'][`${selectedTipoGenerica.cgCampo}`];
                        }
                        else {
                            let guid = window.crypto.randomUUID();
                            console.log(guid);

                            sequenceTgContenedor = guid;

                        }

                        //console.log("sequenceTgContenedor, ", selectedTipoGenerica, "genericaSistema, ", genericaSistema);
                        //if (genericaSistema.id>0){
                        return (
                            <div className={classNames({ 'fieldCustom p-invalid': !pregunta.uts['valido'] && pregunta.ingresado })}>
                                <div>
                                    {(valRefDoc !== null && valRefDoc !== undefined && valRefDoc !== "") ? (<Link target="_blank" icon="pi pi-download" rel="noopener noreferrer" to={"file?guid=" + valRefDoc}>Adjunto</Link>) : <span>No hay archivos cargados</span>}
                                </div>

                            </div>

                        );

                    }
                    else { return (<span>Archivo no carga </span>) }
            }

        }
        else {

            switch (pregunta.uts['tipoDato']) {
                case "boolean":
                    val = (val === undefined) ? false : ((typeof val === "boolean") ? val : val.toLowerCase() === "true");
                    return (<Checkbox id={`bt${pregunta.id}`} checked={val} ref={e => pregunta.formRef = e} onChange={(e) => onBooleanChange(e, pregunta.campo)} ></Checkbox>);
                case "int": return (<InputNumber id={`bt${pregunta.id}`} value={val} ref={e => pregunta.formRef = e} onValueChange={(e) => onInputNumberChange(e, pregunta.campo)} className={classNames({ 'p-invalid': pregunta.uts['ingresado'] && !pregunta.uts['valido'] })} />);
                case "sequence": return (<InputNumber id={`bt${pregunta.id}`} readOnly value={val} ref={e => pregunta.formRef = e} onValueChange={(e) => onInputNumberChange(e, pregunta.campo)} className={classNames({ 'p-invalid': pregunta.uts['ingresado'] && !pregunta.uts['valido'] })} />);
                case "double": return (<InputNumber id={`bt${pregunta.id}`} mode="decimal" value={val} ref={e => pregunta.formRef = e} onValueChange={(e) => onInputNumberChange(e, pregunta.campo)} className={classNames({ 'p-invalid': pregunta.uts['ingresado'] && !pregunta.uts['valido'] })} />);
                case "text": return (<div className={classNames({ 'fieldCustom p-invalid': pregunta.uts['ingresado'] && !pregunta.uts['valido'] })}><Editor translate='no' id={`bt${pregunta.id}`} headerTemplate={headerTemplateEditor} style={{ height: '10rem' }} value={val} ref={e => pregunta.formRef = e} onTextChange={(e) => onInputChange(e, pregunta)} /></div>);
                case "text2": return (<InputTextarea id={`bt${pregunta.id}`} value={val} ref={e => pregunta.formRef = e} onChange={(e) => onInputChange(e, pregunta)} className={classNames({ 'p-invalid': pregunta.uts['ingresado'] && !pregunta.uts['valido'] })} />);
                case "date": return (<Calendar id={`bt${pregunta.id}`} showButtonBar yearNavigator={false} yearRange="2010:2030" showIcon dateFormat="dd/mm/yy"
                    value={val} ref={e => pregunta.formRef = e} required onChange={(e) => onInputChange(e, pregunta.campo)} className={classNames({ 'p-invalid': pregunta.uts['ingresado'] && !pregunta.uts['valido'] })} />);
                case "date": return (<Calendar id={`bt${pregunta.id}`} showButtonBar yearNavigator={false} yearRange="2010:2030" showIcon dateFormat="dd/mm/yy"
                    value={val} ref={e => pregunta.formRef = e} required onChange={(e) => onInputChange(e, pregunta.campo)} className={classNames({ 'p-invalid': pregunta.uts['ingresado'] && !pregunta.uts['valido'] })} />);
                case "ref2": return (<Inplace closable ref={e => pregunta.formRef = e} style={{ width: '95%' }}>
                    <InplaceDisplay>
                        {valRef || val} || 'Click para Seleccionar'
                    </InplaceDisplay>
                    <InplaceContent>
                        <DataTableListGenerica selectedTipoGenerica={refTg} onSelectedItem={onSelectedItem} metadataRef={pregunta}></DataTableListGenerica>
                    </InplaceContent>
                </Inplace>);
                case "ref":

                    let campoCtiTextoOptionsSelectButton = 'ctiTextovalor';
                    let campoOptionsSelectButton = 'valor';
                    let formatoDatoRef = pregunta['uts'][`${"formatoDato"}`];

                    val = pregunta['uts'][`${"valor"}`];
                    const valRef = pregunta['uts'][`${"ctiTextovalor"}`];


                    if (pregunta.uts['refFactorForma'] === "selectbutton") {

                        let items = [];
                        items = genericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA.filter(x => x.tg === tgPreguntaReferenciada
                            && x.uts["tgRef"] === formatoDatoRef).map(x => ({ ...x, value: x.uts[campoOptionsSelectButton] + '', 'name': x.uts[campoCtiTextoOptionsSelectButton] }));;

                        return (
                            <SelectButton value={val} optionLabel="name" itemTemplate={selectButtonBodyItemTemplate}
                                options={items} style={{ display: "flex" }} disabled={submitting}
                                onChange={(e) => { if (e.value !== null) onChangeSelectButton({ rowData: pregunta, newValue: e.value, field: campoOptionsSelectButton, originalEvent: e }) }}
                                className={classNames({ 'p-invalid': pregunta.uts['ingresado'] && !pregunta.uts['valido'] })}
                            //onChange={(e) => { if (e.value !== null) options.editorCallback(e.value) }}
                            //let { rowData, newValue, field, originalEvent: event } = e;

                            //readOnly={true} 
                            />
                        );


                    }
                    else {

                        // para los casos que obligatoriamente se van a consultar como listado desplegable

                        //const valRef = genericaSistema['uts'][`${"ctiTexto" + pregunta.campo}`];


                        //let refTg = { "tg": pregunta.uts['formatoDato'], "cti": "TG-SYS-ACA_UNIDAD", "ctiTexto": pregunta.uts['ctiTextoformatoDato'] };

                        let refTg = {
                            "tg": "BAS_REFERENCIA-REF_FMT_VSTA_RESPUESTA_REFERENCIADA_ITEM",
                            "cti": pregunta.uts['ctiTextoformatoDato'] || pregunta.uts['formatoDato']
                        };
                        let metadataRef = {
                            "tg": pregunta.uts['formatoDato'], //selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE.tg,
                            campo: "valor",
                            refCampoTg: "valor",
                            tipoDato: pregunta.uts['tipoDato'],
                            referenciaRef: pregunta.uts['pregunta'],
                            formatoDato: pregunta.uts['formatoDato'],
                            camposFiltroRef: 'valor,ctiTextovalor,ctiTextoDescvalor',
                            formRef: pregunta.formRef,
                        };

                        //refTg.filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                        /*if (metadata.dominioDato !== null && metadata.dominioDato !== "") {
                            refTg.tg = metadata.dominioDato;
                        }*/

                        if (pregunta.esSoloLectura) {
                            return (<div className={classNames({ 'fieldCustom p-invalid': !pregunta.uts['valido'] && pregunta.ingresado })}>

                                <span>{valRef}</span>

                            </div>);
                        }
                        else {
                            return (<div className={classNames({ 'fieldCustom p-invalid': !pregunta.uts['valido'] && pregunta.ingresado })}>


                                <Button id={`bt${pregunta.uts[campoRespuestaFormatoDiligenciadoRef.current]}`} type="button" icon="pi pi-search" label={valRef ? valRef || val : 'Click para Seleccionar'} style={{ width: '30%', minWidth: '10rem' }} onClick={(e) => showOverlayPanel(e, `${pregunta.uts[campoRespuestaFormatoDiligenciadoRef.current]}`)} aria-haspopup aria-controls="overlay_panel" className="select-product-button" />

                                <OverlayPanel ref={e => pregunta.formRef = e} showCloseIcon style={{ width: '80%', 'margin-top': '2%', 'margin-left': '2%' }} className="overlaypanel-demo">
                                    <DataTableListGenerica selectedTipoGenerica={refTg} onSelectedItem={onSelectedItem} metadataRef={metadataRef} etiquetasModulo={etiquetasModulo}></DataTableListGenerica>
                                </OverlayPanel>
                            </div>);
                        }

                    }
                case "refDep": return (<div className={classNames({ 'fieldCustom': true }, { 'p-invalid': !pregunta.uts['valido'] })}>

                    <Button id={`bt${pregunta.uts[campoRespuestaFormatoDiligenciadoRef.current]}`} type="button" icon="pi pi-search" label={valRef ? valRef || val : 'Click para Seleccionar'} ref={e => pregunta.formRef = e}
                        style={{ width: '30%', minWidth: '10rem' }} onClick={(e) => showOverlayPanel(e, `${pregunta.campo}`)}
                        aria-haspopup aria-controls="overlay_panel" className="select-product-button" />

                    <OverlayPanel ref={e => pregunta.formRef = e} showCloseIcon style={{ width: '80%', 'margin-top': '5%', 'margin-left': '5%' }} className="overlaypanel-demo">
                        <DataTableListGenerica selectedTipoGenerica={refTg} onSelectedItem={onSelectedItem} metadataRef={pregunta.metadata}>
                        </DataTableListGenerica>
                    </OverlayPanel>
                </div>);

                default: return (<InputText id={`bt${pregunta.id}`} value={val} ref={e => pregunta.formRef = e} required onChange={(e) => onInputChange(e, pregunta)} minLength={pregunta.uts["restriccionFormatoMin"] !== "" ? pregunta.uts["restriccionFormatoMin"] + 0 : undefined} maxLength={pregunta.uts["restriccionFormatoMax"] !== "" ? Number(pregunta.uts["restriccionFormatoMax"]) : undefined} className={classNames({ 'p-invalid': pregunta.uts['ingresado'] && !pregunta.uts['valido'] })} />);

            }

        }


    }

    const onChangeSelectButton = async (e) => {


        let { rowData, newValue, field, originalEvent: event } = e;

        console.log("onCellEditComplete, ", field);

        // validaciones varias que aún están programadas.

        setSubmitted(true);
        setLoadingData(true);

        if (newValue !== undefined && rowData.uts[field] !== newValue) {

            let tgRefOps = selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE.operacionesCampos.find(x => x.tipoOperacion === "EDIT_ROW")

            let genericaSistema = { id: rowData.id, idEmpresa: idEmpresa, idioma: idioma, tg: tgRefOps.tgRef, uts: {} }

            let itemOpsCampo = {};

            for (let i = 0; i < selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE.operacionesCampos[i];
                if (itemOpsCampo.id === tgRefOps.id) {

                    if (itemOpsCampo.campotg === field)
                        genericaSistema.uts[itemOpsCampo.campotgRef] = newValue;
                    else
                        genericaSistema.uts[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];

                }
            }

            genericaSistema.uts[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];
            genericaSistema.uts['valido'] = true
            genericaSistema.uts['ingresado'] = true

            //[field] = newValue;
            let campoCriterio = 'valor';

            if (field === campoCriterio) {
                //let valCriterio = options.rowData.uts[campoCriterio];
                let itemSelected = genericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA.find(x => x.tg === tgPreguntaReferenciada
                    && x.uts[campoCriterio] + '' === newValue);

                if (itemSelected !== undefined) {

                    //genericaSistema.uts['nota'] = itemSelected.uts['notaDefault'];

                }
            }

            console.log("sende, ", genericaSistema);

            guardando.current = true;

            await genericaSistemaService.saveGenericaSistema(idEmpresa, idioma, userName, genericaSistema).then(response => {

                console.log("response222, ", response);


                let genericaSistemaAffect = response.genericasSistemaAffected.find(x => x.tg === selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE.tg);

                if (selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE.tg === genericaSistemaAffect.tg) {

                    //props.onSaveSuccessfull(response.genericasSistemaAffected);


                    if (response.mensaje === "") {

                        if (rowData.id > 0) {
                            //rowData.uts[field] = newValue;
                            rowData.uts = genericaSistemaAffect.uts;
                        }
                        else {
                            rowData.id = genericaSistemaAffect.id;
                            rowData.cti = genericaSistemaAffect.cti;
                            //rowData.uts[field] = newValue;
                            rowData.uts = genericaSistemaAffect.uts;

                            /*const index = findIndexById(rowData.id);
                            let _genericasSistema = [...genericasSistema]
     
                            _genericasSistema[index].id = response.id;
                            _genericasSistema[index].cti = response.cti;
                            if (response.campoSequenceTg!=="")
                            _genericasSistema[index].uts[response.campoSequenceTg] = response.sequenceTg;
     
                            setGenericasSistema(_genericasSistema);*/

                            //_genericaSistema.image = 'genericaSistema-placeholder.svg';
                            //_genericasSistema.unshift(_genericaSistema);
                        }




                        //setGenericaSistemaDialogFormulario(false);
                        //setGenericaSistema(crearNewEmptyGenerica(metadataGenericaSistemaForm));
                    }
                    else {

                        if (rowData.id > 0) {
                            rowData.uts[field] = newValue;
                            //rowData.uts  = genericaSistemaAffect.uts;
                        }
                        else {
                            rowData.id = response.id;
                            rowData.cti = response.cti;
                            if (response.campoSequenceTg !== "")
                                rowData.uts[response.campoSequenceTg] = response.sequenceTg;
                            rowData.uts[field] = newValue;

                            /*const index = findIndexById(rowData.id);
                            let _genericasSistema = [...genericasSistema]
     
                            _genericasSistema[index].id = response.id;
                            _genericasSistema[index].cti = response.cti;
                            if (response.campoSequenceTg!=="")
                            _genericasSistema[index].uts[response.campoSequenceTg] = response.sequenceTg;
     
                            setGenericasSistema(_genericasSistema);*/

                            //_genericaSistema.image = 'genericaSistema-placeholder.svg';
                            //_genericasSistema.unshift(_genericaSistema);
                        }

                    }

                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Guardado', life: 3000 });

                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error Message', detail: response.mensaje });
                }

                guardando.current = false;

            });

            /*
            switch (field) {
                case 'quantity':
                case 'price':
                    if (isPositiveInteger(newValue)) rowData.uts[field] = newValue;
                    else event.preventDefault();
                    break;
    
                default:
                    if (newValue.trim().length > 0) rowData.uts[field] = newValue;
                    else event.preventDefault();
                    break;
            }*/

        }

        setLoadingData(false);

        if (props.onChangeDataInterno) {

            if (selectedTipoGenerica.tg === "ACA_VSTA_MATRICULADOS_DETALLE_PARA_DIGITACION_NOTA_RA" || selectedTipoGenerica.tg === "ACA_VSTA_MATRICULADOS_DETALLE_PARA_DIGITACION_NOTA_RA") {
                //genericasSistema.forEach(x=>)

            }

        }

    };

    const selectButtonBodyItemTemplate = (option) => {
        //console.log("option,", option);

        let campoCtiTextoOptionsSelectButton = 'ctiTextovalor';
        let campoOptionsSelectButton = 'valor';

        return <div className="m-0" dangerouslySetInnerHTML={{ __html: option.uts[campoCtiTextoOptionsSelectButton] }} />
        //return <i className={option.icon}></i>;

    }

    const showOverlayPanel = (e, _campo) => {
        let op = metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO.find(x => x.campo === _campo)
        op.formRef.toggle(e);
        //console.log(op.formRef);
        //op.formRef.visible=true;
    }

    const [numPages, setNumPages] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);

    const onDocumentLoadSuccess = (numPages) => {
        setNumPages(numPages);
    }

    /*
        function PdfPreviewer({ file }) {
            const [numPages, setNumPages] = useState(null);
            const [pageNumber, setPageNumber] = useState(1);
    
            function onDocumentLoadSuccess({ numPages }) {
                setNumPages(numPages);
                setPageNumber(1); // Reset to the first page on new document load
            }
    
            return (
                <div>
                    <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
                        <Page pageNumber={pageNumber} />
                    </Document>
                    <p>
                        Page {pageNumber} of {numPages}
                    </p>
                </div>
            );
        }
        */

    const pdfUrl = async (path) => {

        let fileBase64 = await genericaSistemaService.GetFileBase64(idEmpresa, idioma, userName, path);

        let base64String1 = fileBase64.data;

        // 1. Limpiar el prefijo si existe
        const pureBase64 = base64String1.replace(/^data:application\/pdf;base64,/, "");

        // 2. Convertir a Blob
        const byteCharacters = atob(pureBase64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        //'application/pdf'
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: fileBase64.metadata });

        // 3. Crear la URL

        let url = URL.createObjectURL(blob);

        console.log("urlBlob,", url);

        return url;
    }

    const generarCabeceraCampo = (metadata) => {

        let genericaSistema = genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO[0];
        let metadataGenericaSistemaForm = metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO;

        let val = genericaSistema['uts'][`${metadata.campo}`];
        let refTg = { "tg": metadata.formatoDato, "cti": "TG-SYS-ACA_UNIDAD", "ctiTexto": metadata.ctiTexto };

        const valRef = genericaSistema['uts'][`${"ctiTexto" + metadata.campo}`];

        let modeNumeric = "decimal";
        let currency = undefined;
        let minFractionDigits = 0;
        let maxFractionDigits = 0;

        if (metadata.formatoDato === "previewPdf") {

            console.log("typeof urlPdfPreview, ", typeof urlPdfPreviewRef.current, urlPdfPreviewRef.current);
            if (urlPdfPreviewRef.current === undefined || typeof urlPdfPreviewRef.current !== "string") {

                //pdfUrl(val).then((urlPdf) => setUrlPdfPreview(urlPdf));
                pdfUrl(val).then((urlPdf) => { urlPdfPreviewRef.current = urlPdf; setUrlPdfPreview(urlPdf) });

                return (<>...Cargando...</>)
            }

            else {


                console.log("urlPdfPreview, ", urlPdfPreviewRef);

                return (
                    <div style={{ height: '100vh' }}>

                        <PDFViewer style={{ height: '100vh' }}
                            config={{
                                src: urlPdfPreview,
                                theme: { preference: 'light' }
                            }}
                        />

                    </div>

                );

                return (<div style={{ height: '100vh' }}>


                    <PDFViewer
                        config={{
                            src: 'https://snippet.embedpdf.com/ebook.pdf',
                            permissions: {
                                overrides: {
                                    print: false,
                                    printHighQuality: false,
                                    copyContents: false,
                                    modifyContents: false,
                                    modifyAnnotations: false,
                                    FillForms: false,
                                    ExtractForAccessibility: false,
                                    AssembleDocument: false,
                                    AllowAll: false,
                                }
                            }
                        }}
                        style={{ height: '500px' }}
                        onReady={(registry) => {
                            console.log('PDF viewer ready!', registry);
                        }}
                    />

                </div>);

                /*
                                return (
                                    <div>
                                        <Document file="https://snippet.embedpdf.com/ebook.pdf" onLoadSuccess={({ numPages }) => setNumPages(numPages)}>
                                            <Page pageNumber={pageNumber} />
                                        </Document>
                                        <p>Page {pageNumber} of {numPages}</p>
                                    </div>
                
                
                                    );
                                    */

            }


        }

    }

    const generarMensajeValidacionCampo = (metadata) => {

        let campo = metadata.campo;

        let val = genericaSistema['uts'][`${campo}`];

        let tieneMensajeError = submitted && metadata.tipoDato !== "boolean" && !val && metadata.mensajeError !== "";

        let textoError = tieneMensajeError ? "is required. " + metadata.mensajeError : "";

        //console.log("validaciones campos, ", val, tieneMensajeError, textoError, metadata);

        /*
        switch (metadata.tipoDato){
            case "boolean": return (<Checkbox id={`fieldEdit${metadata.tg+'-'+campo}`} checked={ val }  ref={e => metadataRef.columnRef = e} required onChange={(e) => onBooleanChange(e, campo)} className={classNames({ 'p-invalid': submitted && !genericaSistema.ctiTexto })}></Checkbox>); break;
            case "int": return ( <InputNumber id={`fieldEdit${metadata.tg+'-'+campo}`} value={ val } ref={e => metadataRef.columnRef = e} onValueChange={(e) => onInputNumberChange(e, campo)} />); break;
            case "double": return ( <InputNumber id={`fieldEdit${metadata.tg+'-'+campo}`} value={  val } ref={e => metadataRef.columnRef = e} onValueChange={(e) => onInputNumberChange(e, campo)}  mode="decimal" />); break;
            default: return (<InputText id={`fieldEdit${metadata.tg+'-'+campo}`} value={val } ref={e => metadataRef.columnRef = e} required  onChange={(e) => onInputChange(e, campo)} className={classNames({ 'p-invalid': !pregunta.uts['valido'] })} />); break;
        }
        */

        return (tieneMensajeError && <small className="p-invalid">{metadata.ctiTexto} {textoError}</small>);
    }

    const onClickBotonCancelar = async (e) => {

        setGuidIntento(newGuid);
        setEditando(false);
        var newGuid = window.crypto.randomUUID();

        console.log("newGuid, ", newGuid);

        establecerTipoGenericasFORMULARIO_CALIFICACION(metadataGenericaSistemaTgOperaciones, false, newGuid);

        if (props.onHideForm) {
            setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO([]);
            setGenericasSistema_FORMULARIO_GENERICO_NOTAPADRE([]);
            setGenericasSistema_FORMULARIO_GENERICO_DETALLE([]);
            props.onHideForm(e);
        }
        else {
            lazyParamInit.filters = {};
            let newLazyParamInit = Object.assign({}, lazyParamInit);
            setLazyParams({ ...newLazyParamInit });
            lazyParamsInitSelected.current = newLazyParamInit;
        }

    }


    const saveConfirmacionOPT = async () => {

        console.log("genericaSistemaConfirmacionOpt, ", genericaSistemaConfirmacionOpt);
        setSubmitting(true);

        let dialog = genericaSistemaDialogRef.current;

        let validoGenerica = true;

        let newMetadataGenericaSistemaConfirmacionOpt = [...metadataGenericaSistemaConfirmacionOpt];

        let metadatasfiltered = [];


        metadatasfiltered = metadataGenericaSistemaConfirmacionOpt.filter(x => x.tipoDato !== "label"
            && x.tipoDato !== "sequence" && x.esImprimible === true && x.esSoloLectura === false
            && (x.esRequerido === true && x.actualizableEnFormulario === true))

        //  incuir esto?       (selectedTipoGenerica.filtroUts && Object.keys(selectedTipoGenerica.filtroUts).includes(x.campo))


        /*
       newMetadataGenericaSistemaForm.filter(x => x.valido === false && x.tipoDato !== "label" && x.actualizableEnFormulario === true && x.esSoloLectura === false
           && !(x.tipoDato === "sequence" || (selectedTipoGenerica.filtroUts && Object.keys(selectedTipoGenerica.filtroUts).includes(x.campo))))
           
           newMetadataGenericaSistemaForm.forEach(x => {
               validoGenerica = validoGenerica && x.valido;
               x.ingresado = true;
           });
           */


        let metadataFiltered = undefined;
        let metadata = undefined;
        let newMetada = undefined;
        let index = undefined;

        for (let indexFiltered in metadatasfiltered) {

            metadataFiltered = metadatasfiltered[indexFiltered];
            index = newMetadataGenericaSistemaConfirmacionOpt.findIndex(x => x.campo === metadataFiltered.campo);
            metadata = newMetadataGenericaSistemaConfirmacionOpt[index];

            newMetada = generarValidadoresMetadata(metadata, undefined, true, genericaSistemaConfirmacionOpt);
            newMetada.formRef = metadata.formRef;

            newMetadataGenericaSistemaConfirmacionOpt[index] = newMetada;

            //newMetada.ingresado = true;

            if (newMetada.valido === false) {
                console.log("newMetada.valido", newMetada);
            }

            validoGenerica = validoGenerica && newMetada.valido;

        }

        setMetadataGenericaSistemaConfirmacionOpt(newMetadataGenericaSistemaConfirmacionOpt);

        console.log("newMetadataGenericaSistemaForm, ", metadatasfiltered.filter(x => x.valido === false));

        if (validoGenerica) {

            metadataGenericaSistemaConfirmacionOpt.filter(x => x.esSoloLectura && x.valorDefecto !== null && x.valorDefecto !== "")
                .forEach(campoSoloLectura => {
                    let valDefault = undefined;

                    switch (campoSoloLectura.valorDefecto) {
                        case "__SYSTEM_NOW": valDefault = new Date(Date.now()); break;
                        case "__SYSTEM_ID_TERCERO_USER_NAME": valDefault = null; break;
                        case "__SYSTEM_UUID":
                            var uuid = window.crypto.randomUUID();
                            valDefault = uuid.toString(); break;
                        case "__UPDATE_SYSTEM_NOW": valDefault = new Date(Date.now()); break;
                        case "__UPDATE_SYSTEM_ID_TERCERO_USER_NAME": valDefault = null; break;
                    }

                    genericaSistemaConfirmacionOpt.uts[campoSoloLectura.campo] = valDefault;

                });

            console.log("savegenericaSistema, ", genericaSistemaConfirmacionOpt);

            await genericaSistemaService.saveGenericaSistema(idEmpresa, idioma, userName, genericaSistemaConfirmacionOpt).then(response => {

                console.log("response, ", response);
                if (response.mensaje === "") {

                    let _genericaSistema = { ...genericaSistemaConfirmacionOpt };

                    let idOriginal = _genericaSistema.id;

                    if (genericaSistema.id > 0) {
                        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Actualizado', life: 3000 });
                    }
                    else {
                        // Confirmación existosa


                        setGuidIntento(newGuid);
                        setEditando(false);

                        var newGuid = window.crypto.randomUUID();
                        console.log("newGuid, ", newGuid);

                        establecerTipoGenericasFORMULARIO_CALIFICACION(metadataGenericaSistemaTgOperaciones, false, newGuid);

                        lazyParamInit.filters = {};
                        let newLazyParamInit = Object.assign({}, lazyParamInit);
                        setLazyParams({ ...newLazyParamInit });
                        lazyParamsInitSelected.current = newLazyParamInit;

                        setSubmitting(false);

                        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Actualizado', life: 3000 });

                        //onSaveSuccessfullDataTableGenericaCalificacion([]); 

                        //Fin del cierre

                        //_genericaSistema.image = 'genericaSistema-placeholder.svg';
                        //_genericasSistema.unshift(_genericaSistema);
                        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Guardado', life: 3000 });
                    }

                    if (requiereConfirmacionOPT) {
                        setEsperandoConfirmacionOPT(false);
                    }


                    console.log("finaliza pagare");
                    
                    if (props.onSaveSuccessful) { props.onSaveSuccessful(response.genericasSistemaAffected); }


                    //setGenericasSistema(_genericasSistema);
                    //setGenericaSistemaDialog(false);
                    //setGenericaSistema(crearNewEmptyGenerica(metadataGenericaSistemaForm));
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error Message', detail: response.mensaje });
                }

                setSubmitting(false);

            });

        }
        else {
            setSubmitting(false);
            toast.current.show({ severity: 'error', summary: 'Error Message', detail: "Se encontraron errores en los datos" });
        }

    }

    const savegenericaSistema = async () => {

        //setEditando(true);
        setSubmitting(true);
        let dialog = genericaSistemaDialogRef.current;

        let validoGenerica = true;

        let newMetadataGenericaSistemaForm = [...metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO];

        let metadatasfiltered = [];

        let genericaSistema = genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO[0];

        if (genericaSistema.id <= 0) {
            metadatasfiltered = newMetadataGenericaSistemaForm.filter(x => x.tipoDato !== "label"
                && x.tipoDato !== "sequence" && x.esImprimible === true && x.esSoloLectura === false
                && (x.esRequerido === true || x.requeridoParaNuevo === true))
        }
        else {
            metadatasfiltered = newMetadataGenericaSistemaForm.filter(x => x.tipoDato !== "label"
                && x.tipoDato !== "sequence" && x.esImprimible === true && x.esSoloLectura === false
                && (x.esRequerido === true || x.actualizableEnFormulario === true))

            //  incuir esto?       (selectedTipoGenerica.filtroUts && Object.keys(selectedTipoGenerica.filtroUts).includes(x.campo))
        }

        let metadataFiltered = undefined;
        let metadata = undefined;
        let newMetada = undefined;
        let index = undefined;

        for (let indexFiltered in metadatasfiltered) {

            metadataFiltered = metadatasfiltered[indexFiltered];
            index = newMetadataGenericaSistemaForm.findIndex(x => x.campo === metadataFiltered.campo);
            metadata = newMetadataGenericaSistemaForm[index];

            newMetada = generarValidadoresMetadata(metadata, undefined, true);
            newMetada.formRef = metadata.formRef;


            newMetadataGenericaSistemaForm[index] = newMetada;

            //newMetada.ingresado = true;

            if (newMetada.valido === false) {
                console.log("newMetada.valido", newMetada);
            }

            validoGenerica = validoGenerica && newMetada.valido;

        }

        setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO(newMetadataGenericaSistemaForm);


        var newGuid = window.crypto.randomUUID();

        //console.log(selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO);


        if (!validoGenerica) {
            setSubmitting(false);
            toast.current.show({ severity: 'error', summary: 'Error Message', detail: "Se encontraron errores en los datos" });
        }
        else {

            metadataGenericaSistemaForm.filter(x => x.esSoloLectura && x.valorDefecto !== null && x.valorDefecto !== "")
                .forEach(campoSoloLectura => {
                    let valDefault = undefined;

                    switch (campoSoloLectura.valorDefecto) {
                        case "__SYSTEM_NOW": valDefault = new Date(Date.now()); break;
                        case "__SYSTEM_ID_TERCERO_USER_NAME": valDefault = null; break;
                        case "__SYSTEM_UUID":
                            var uuid = window.crypto.randomUUID();
                            valDefault = uuid.toString(); break;
                        case "__UPDATE_SYSTEM_NOW": valDefault = new Date(Date.now()); break;
                        case "__UPDATE_SYSTEM_ID_TERCERO_USER_NAME": valDefault = null; break;
                    }

                    genericaSistema.uts[campoSoloLectura.campo] = valDefault;

                });



            let tgRefOps = selectedTipoGenerica.operacionesCampos
                .find(x => x.seccion === "FORMULARIO_GENERICO_INTENTO_TMP" && x.tipoOperacion === "FORMULARIO_CALIFICACION_COMPLETAR_INTENTO")
            if (tgRefOps) {


                //setSelectedTipoGenerica(newSelectedTipoGenerica);

                let genericasSistemaIntento = genericasSistema_FORMULARIO_GENERICO_INTENTO[0];

                let newGenericaSistema = { id: genericasSistemaIntento.id, idEmpresa: idEmpresa, idioma: idioma, tg: tgRefOps.tgRef, uts: {} }
                newGenericaSistema.uts['uuidintento'] = guidIntento;

                let itemOpsCampo = {};

                for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                    itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                    if (itemOpsCampo.id === tgRefOps.id) {
                        if (tgRefOps.tgRef === "FMT_VSTA_CLONE_FORMATO_DILIGENCIADO_PARA_COMPLETAR_INGRESO1111"
                            || tgRefOps.tgRef === "BPM_VSTA_SOLICITUD_CD_INTENTO_VERIFICACION_PAGARE_OPT"
                        ) {
                            newGenericaSistema.uts[itemOpsCampo.campotgRef] = genericasSistemaIntento.uts[itemOpsCampo.campotgRef];
                        }
                        else {
                            newGenericaSistema.uts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                        }
                    }

                }

                //let children = newGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO.map(gen => ({ ...gen, formRef: null, columnRef: null, mensajeError: "" }));

                console.log("genericasSistemaIntento, ");
                await genericaSistemaService.saveGenericaSistema(idEmpresa, idioma, userName, newGenericaSistema).then(response => {

                    if (response.mensaje === "") {


                        if (requiereConfirmacionOPT) {
                            let newGenericaSistemaConfirmacionOpt =
                            {
                                id: response.id, idEmpresa: idEmpresa, tg:
                                    selectedTipoGenericaConfirmacionOpt.tg, ctiTexto: "", uts: {
                                        'uuidintento': guidIntento,
                                        'solicitud': newGenericaSistema.uts["solicitud"],
                                        //'intentoDiligenciamiento' : newGenericaSistema.uts["intentoDiligenciamiento"],
                                    }
                            };
                            setGenericaSistemaConfirmacionOpt(newGenericaSistemaConfirmacionOpt);
                            setEsperandoConfirmacionOPT(true);
                        }
                        else {
                            props.onSaveSuccessful(_genericaSistema, idOriginal, response.genericasSistemaAffected);
                        }

                        setSubmitting(false);

                        //setGenericasSistema(_genericasSistema);
                        //setGenericaSistemaDialog(false);
                        //setGenericaSistema(crearNewEmptyGenerica(metadataGenericaSistemaForm));
                    }
                    else {

                        setSubmitting(false);

                        toast.current.show({ severity: 'error', summary: 'Error Message', detail: response.mensaje });
                    }

                });



            }

        }





        /*
     
     
     
    genericaSistema[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];
     
    console.log("sende, ", genericaSistema);
     
    let dialog = genericaSistemaDialogRef.current;
     
    */



    }

    const onEditarFormularioFactura = async (e, genericaOrigen) => {

        setSubmitting(true);
        setCreandoFormulario(true);

        var newGuid = window.crypto.randomUUID();

        //console.log(selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO);

        let tgRefOps = selectedTipoGenerica.operacionesCampos
            .find(x => x.seccion === "FORMULARIO_GENERICO_INTENTO_TMP" && x.tipoOperacion === "FORMULARIO_CALIFICACION_CREAR_INTENTO")
        if (tgRefOps) {


            //setSelectedTipoGenerica(newSelectedTipoGenerica);

            let newGenericaSistema = { id: -1, idEmpresa: idEmpresa, idioma: idioma, tg: tgRefOps.tgRef, uts: {} }
            newGenericaSistema.uts['uuidintento'] = newGuid;


            let genericasSistemaConsolidado = genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO[0];
            let genericaSistemaBase = genericaSistema;

            if (genericaOrigen !== undefined && genericaOrigen !== null) {
                newGenericaSistema.uts['solicitud'] = 0;
                genericasSistemaConsolidado = genericaOrigen;
                genericaSistemaBase = genericaOrigen;
            }



            let itemOpsCampo = {};

            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === tgRefOps.id) {
                    if (itemOpsCampo.campotgRef === "matricula" && selectedTipoGenerica.tg === "FMT_FORMATO_EVALUACION-RAP_MOODLE") {
                        // esto hay que organizarlo mejor
                        newGenericaSistema.uts[itemOpsCampo.campotgRef] = genericasSistemaConsolidado.uts[itemOpsCampo.campotgRef];
                    }
                    else {
                        console.log("itemOpsCampo.campotg, ", itemOpsCampo.campotg, itemOpsCampo.tgRef, "genericaSistemaBase, ", genericaSistemaBase);
                        newGenericaSistema.uts[itemOpsCampo.campotgRef] = genericaSistemaBase.uts[itemOpsCampo.campotg];
                    }

                }
            }

            /*
            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = newSelectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === tgRefOps.id) {
                    genericaSistema.uts[itemOpsCampo.campotgRef] = genericasSistemaConsolidado.uts[itemOpsCampo.campotg];
                }
    
            }*/


            setLoadingLazyData(true);

            console.log("onEditarFormularioFactura, ", newGuid);

            await genericaSistemaService.saveGenericaSistema(idEmpresa, idioma, userName, newGenericaSistema).then(response => {
                // para crear intento
                setCreandoFormulario(false);
                if (response.mensaje === "") {


                    setTimeout(() => {

                        setEditando(true);
                        setIntentoCalculadora(0);
                        setGuidIntento(newGuid);

                        console.log("newGuid, ", newGuid);

                        establecerTipoGenericasFORMULARIO_CALIFICACION(metadataGenericaSistemaTgOperaciones, true, newGuid);

                        lazyParamInit.filters = {};
                        let newLazyParamInit = Object.assign({}, lazyParamInit);
                        setLazyParams({ ...newLazyParamInit });
                        lazyParamsInitSelected.current = newLazyParamInit;

                        setSubmitting(false);

                        //toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Actualizado', life: 3000 });

                    }, 100);



                    //props.onSaveSuccessful(_genericaSistema, idOriginal, response.genericasSistemaAffected);

                    //setGenericasSistema(_genericasSistema);
                    //setGenericaSistemaDialog(false);
                    //setGenericaSistema(crearNewEmptyGenerica(metadataGenericaSistemaForm));
                }
                else {
                    setSubmitting(false);
                    toast.current.show({ severity: 'error', summary: 'Error Message', detail: response.mensaje });
                }

            });



        }


        /*
    
     
     
    genericaSistema[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];
    
    console.log("sende, ", genericaSistema);
    
    let dialog = genericaSistemaDialogRef.current;
    
    */



    }


    const zzzsavegenericaSistema = async () => {

        //setEditando(true);

        var newGuid = window.crypto.randomUUID();

        //console.log(selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO);

        await genericaSistemaService.GetTipoGenericaSistemaByTg({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO.tg).then(async data => {

            let newSelectedTipoGenerica = data.data;

            if (selectedTipoGenerica.filtroUts !== undefined) {
                newSelectedTipoGenerica.filtroUts = { ...selectedTipoGenerica.filtroUts };
                newSelectedTipoGenerica.ctiTextoFiltroUts = selectedTipoGenerica.ctiTextoFiltroUts
            }
            if (selectedTipoGenerica.variableRestriccionExterna !== undefined) {
                newSelectedTipoGenerica.variableRestriccionExterna = { ...selectedTipoGenerica.variableRestriccionExterna };
            }
            else {
                newSelectedTipoGenerica.variableRestriccionExterna = {};
            }

            if (selectedTipoGenerica.operacionesCampos == undefined || !_.isEqual(selectedTipoGenerica.operacionesCampos, data.data.operacionesCampos)) {
                newSelectedTipoGenerica.operacionesCampos = [...data.data.operacionesCampos];
            }
            if (selectedTipoGenerica.version !== undefined) {
                newSelectedTipoGenerica.version = selectedTipoGenerica.version;
            }

            let tgRefOps = newSelectedTipoGenerica.operacionesCampos
                .find(x => x.seccion === "FORMULARIO_GENERICO_INTENTO_TMP" && x.tipoOperacion === "FORMULARIO_CALIFICACION_COMPLETAR_INTENTO")
            if (tgRefOps) {


                //setSelectedTipoGenerica(newSelectedTipoGenerica);

                let genericaSistema = { id: -1, idEmpresa: idEmpresa, idioma: idioma, tg: tgRefOps.tgRef, uts: {} }
                //genericaSistema.uts['guidintentoDiligenciamiento'] = newGuid;

                let genericasSistemaConsolidado = genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO[0];

                let itemOpsCampo = {};

                for (let i = 0; i < newSelectedTipoGenerica.operacionesCampos.length; i++) {
                    itemOpsCampo = newSelectedTipoGenerica.operacionesCampos[i];
                    if (itemOpsCampo.id === tgRefOps.id) {
                        genericaSistema.uts[itemOpsCampo.campotgRef] = genericasSistemaConsolidado.uts[itemOpsCampo.campotg];
                    }

                }

                await genericaSistemaService.saveGenericaSistema(idEmpresa, idioma, userName, genericaSistema).then(response => {

                    if (response.mensaje === "") {


                        setTimeout(() => {

                            setGuidIntento(newGuid);
                            setEditando(false);

                            console.log("newGuid, ", newGuid);

                            establecerTipoGenericasFORMULARIO_CALIFICACION(metadataGenericaSistemaTgOperaciones, false, newGuid);

                            lazyParamInit.filters = {};
                            let newLazyParamInit = Object.assign({}, lazyParamInit);
                            setLazyParams({ ...newLazyParamInit });
                            lazyParamsInitSelected.current = newLazyParamInit;

                            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Actualizado', life: 3000 });

                        }, 100);



                        //props.onSaveSuccessful(_genericaSistema, idOriginal, response.genericasSistemaAffected);

                        //setGenericasSistema(_genericasSistema);
                        //setGenericaSistemaDialog(false);
                        //setGenericaSistema(crearNewEmptyGenerica(metadataGenericaSistemaForm));
                    }
                    else {
                        toast.current.show({ severity: 'error', summary: 'Error Message', detail: response.mensaje });
                    }

                });



            }
        });


        /*
     
     
     
    genericaSistema[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];
     
    console.log("sende, ", genericaSistema);
     
    let dialog = genericaSistemaDialogRef.current;
     
    */



    }



    const accept = () => {
        toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
        savegenericaSistema();
    };

    const reject = () => {
        toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    };


    const showTemplateConfirmDestinoOpt = () => {
        confirmDialog({
            group: 'templating',
            header: 'Confirmation', acceptLabel: "Si", rejectLabel: "No",
            message: (
                <div className="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border">
                    <i className="pi pi-exclamation-circle text-6xl text-primary-500"></i>
                    <span>Desde este momento se procederá con la firma del pagaré, para lo cuál se le enviará un código de seguridad al contacto destino seleccionado.</span>
                    <span>Si no lo ha recibido, por favor verifique en su celular o correo en los mensajes no deseados o bloqueados</span>
                    <span>Está seguro que desea proceder?</span>
                </div>
            ),
            accept,
            reject
        });
    };


    const genericaSistemaDialogFooter = () => {

        //console.log("editando, ", editando);
        if (editando) {

            return (<>

                <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={onClickBotonCancelar} />

                {
                    (function () {

                        //rounded text raised                         
                        if (genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO.length > 0) {
                            return (<>


                                <Button label="Guardar" ref={refBtGuardarDialogFooter} icon="pi pi-check" className="p-button-text"
                                    onClick={() => { selectedTipoGenerica.tg === "BPM_VSTA_SOLICITUD_CD_INVITADO_VERIFICACION_PAGARE" ? showTemplateConfirmDestinoOpt() : savegenericaSistema() }} disabled={submitting} />

                                <ConfirmDialog group="templating" />

                            </>);

                            //onClick={() => {selectedTipoGenerica.tg === "BPM_VSTA_SOLICITUD_CD_INVITADO_VERIFICACION_PAGARE" ? setVisibleConfirm(true) : savegenericaSistema()}} disabled={submitting} />

                            //<ConfirmPopup target={refBtGuardarDialogFooter.current} acceptLabel='Sí' rejectLabel='No' visible={visibleConfirm} onHide={() => setVisibleConfirm(false)} message="Está seguro que desea proceder?" icon="pi pi-exclamation-triangle" accept={accept} reject={reject} />



                        }
                    })()
                }



            </>);

        }
        else if (props.onHideForm) {
            return (<Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={props.onHideForm} />);
        }
        else {
            return (<></>);
        }


    }

    const onClickEditarFormularioFactura = async () => {

    }

    const FormularioFacturaHeader = () => {

        if (modoEdicion && !editando) {

            if (genericaSistema !== undefined && genericaSistema.tg === "FMT_FORMATO-0"
                //&& genericaSistema.uts["VistaMoodle"] !== undefined && genericaSistema.uts["VistaMoodle"] === "viewUpdateGradeRA"
            ) {
                return (
                    <>
                        <Button label="Iniciar Diligenciamiento" icon="pi pi-pencil" raised={true} outlined onClick={onEditarFormularioFactura}
                            disabled={submitting} />
                    </>
                );
            }
            else {
                return (<></>);
            }

        }
        else if (modoEdicion) {

            return (
                <>
                    <span> Editando</span>
                </>
            );

        }
        else {
            return (
                <>
                    <span>Modo Sólo lectura</span>
                </>
            );
        }
    }

    const onChangeDataInterno = (e, metadataRef) => {
    }

    const onSaveSuccessfullDataTableGenericaCalificacion = (valuesAffected) => {

        var newGuid = window.crypto.randomUUID();
        //console.log("valuesAffected, ", guidVersion.current, valuesAffected);
        //guidVersion.current = window.crypto.randomUUID();

        setSelectedTipoGenerica_FORMULARIO_GENERICO_INTENTO({ ...selectedTipoGenerica_FORMULARIO_GENERICO_INTENTO, version: newGuid });
        setSelectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO({ ...selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO, version: newGuid });
        setSelectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE({ ...selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE, version: newGuid });
        setSelectedTipoGenerica_FORMULARIO_GENERICO_DETALLE({ ...selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE, version: newGuid });

        setLazyParams({ ...lazyParams });

    }

    const generarCamposConfirmacionOPT = () => {

        let metadatafiltered = [];

        if (genericaSistema.id <= 0) {
            metadatafiltered = metadataGenericaSistemaConfirmacionOpt.filter(x => x.tipoDato !== "label" && x.tipoDato !== "sequence" && x.esImprimible === true && x.esSoloLectura === false && (x.requeridoParaNuevo === true))
        }
        else {
            metadatafiltered = metadataGenericaSistemaConfirmacionOpt.filter(x => x.tipoDato !== "label" && x.tipoDato !== "sequence" && x.esImprimible === true && x.esSoloLectura === false && (x.actualizableEnFormulario === true))
        }

        return metadatafiltered.map((metadata, index, array) => {

            if (metadata.tipoDato === "sequence" || (selectedTipoGenerica.filtroUts && Object.keys(selectedTipoGenerica.filtroUts).includes(metadata.campo))) {
                return (<></>);

            }

            else {

                let refsGenericaBase = {
                    genericaSistemaBase: genericaSistemaConfirmacionOpt,
                    setterGenericaBase: setGenericaSistemaConfirmacionOpt,
                    metadataGenericaBase: metadataGenericaSistemaConfirmacionOpt,
                    setterMetadataGenericaBase: setMetadataGenericaSistemaConfirmacionOpt
                };

                return (<>
                    <div className="field  col-12 lg:col-5">
                        {generarDescripcionCampo(metadata)}
                        <div className='flex lg:align-items-start'>
                            {generarCampo(metadata, refsGenericaBase)}
                        </div>

                    </div>

                </>);
            }
        });

    }

    const generarDescripcionCampo = (metadata) => {

        if (metadata) {

            if (!metadata.ctiTextoDesc) {
                return (
                    <>
                        <label className='flex align-items-start' id={`label${metadata.tg}-${metadata.campo}`}>{metadata.ctiTexto} {generarInformacionComplementariaCampo(metadata)} </label>
                    </>
                );
            }
            else if (metadata.ctiTextoDesc && metadata.ctiTextoDescVisibilidad === "VISIBLE_BEFORE") {
                return (
                    <>
                        <label className='flex align-items-start' id={`label${metadata.tg}-${metadata.campo}`}> {generarInformacionComplementariaCampo(metadata)} </label>
                        <div className='justify-content-around' style={{ wordBreak: "break-word" }} dangerouslySetInnerHTML={{ __html: metadata.ctiTextoDesc }} />
                        {metadata.ctiTexto}
                    </>
                );
            }
            else
                return (
                    <>
                        <label id={`label${metadata.tg}-${metadata.campo}`}>{metadata.ctiTexto} {generarInformacionComplementariaCampo(metadata)} </label>
                        <div style={{ wordBreak: "break-word" }} dangerouslySetInnerHTML={{ __html: metadata.ctiTextoDesc }} />
                    </>
                );

        }
        else return (<></>);

    }

    const generarInformacionComplementariaCampo = (metadata) => {

        //let refTg = { "tg": metadata.formatoDato, "cti": "TG-SYS-ACA_UNIDAD", "ctiTexto": metadata.ctiTexto };

        //<Chip label="2 de 100" />
        return (<>
            {
                (function () {
                    if (metadata.esRequerido) {
                        return (<Tag className="mr-2" icon="pi pi-info-circle" severity="info" value=""></Tag>);
                    }
                    else {
                        return (<></>);
                    }
                })()

            }

            {
                (function () {
                    if (metadata.tipoDato === "int" || metadata.tipoDato === "double" || metadata.tipoDato === "money") {
                        if (metadata.valMin !== undefined && metadata.valMin >= metadata.valEval) {
                            return (<Chip label={`Mayor o igual a ${metadata.valMin}`} />);
                        }
                        else if (metadata.valMax !== undefined && metadata.valMax <= metadata.valEval) {
                            return (<Chip label={`Menor o igual que ${metadata.valMax}`} />);
                        }

                    }
                    else if (metadata.tipoDato === "date") {
                        if (metadata.valMin !== undefined && metadata.valMin >= metadata.valEval) {
                            return (<Chip label={`Mayor o igual que ${metadata.valMin}`} />);
                        }
                        else if (metadata.valMax !== undefined && metadata.valMax <= metadata.valEval) {
                            return (<Chip label={`Menor o igual que ${metadata.valMax}`} />);
                        }

                    }
                    else if (metadata.tipoDato === "text") {

                        if (metadata.valMin !== undefined && metadata.valMin >= metadata.valEval) {
                            return (<><Chip label={`${metadata.valEval} de mínimo ${metadata.valMin} palabra(s).`} /></>);
                        }
                        else if (metadata.valMax !== undefined && metadata.valMax <= metadata.valEval) {
                            return (<><Chip label={`${metadata.valEval} de ${metadata.valMax} palabras`} /></>);
                        }
                    }
                    else if (metadata.tipoDato === "string") {
                        if (metadata.valMin !== undefined && metadata.valMin >= metadata.valEval) {
                            return (<><Chip label={`${metadata.valEval} de mínimo ${metadata.valMin} letras(s).`} /></>);
                        }
                        else if (metadata.valMax !== undefined && metadata.valMax <= metadata.valEval) {
                            return (<><Chip label={`${metadata.valEval} de ${metadata.valMax} letras máximo`} /></>);
                        }
                    }
                })()
            }
        </>);

    }

    const confirmacionOPTFooter = () => {
        if (utilizaDialog) {
            return (<>
                <ConfirmPopup target={refBtGuardarDialogFooter.current} acceptLabel='Sí' rejectLabel='No' visible={visibleConfirm} onHide={() => setVisibleConfirm(false)}
                    message="Está seguro que desea proceder?" icon="pi pi-exclamation-triangle" accept={accept} reject={reject} />

                <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={props.onHideForm} disabled={submitting} />
                <Button label="Enviar" ref={refBtGuardarDialogFooter} icon="pi pi-check" className="p-button-text" onClick={() => selectedTipoGenerica.tg === "BPM_VSTA_SOLICITUD_SEGUIMIENTO_CIERRE_CJ" ? setVisibleConfirm(true) : saveConfirmacionOPT()} disabled={submitting} />
            </>);
        }
        else {
            return (<div className='col-12 mt-5'>
                <ConfirmPopup target={refBtGuardarDialogFooter.current} acceptLabel='Sí' rejectLabel='No' visible={visibleConfirm} onHide={() => setVisibleConfirm(false)}
                    message="Está seguro que desea proceder?" icon="pi pi-exclamation-triangle" accept={accept} reject={reject} />

                <Button label="Guardar" ref={refBtGuardarDialogFooter} icon="pi pi-check" className="mt-4 bg-white text-green-600 surface-border" onClick={() => selectedTipoGenerica.tg === "BPM_VSTA_SOLICITUD_SEGUIMIENTO_CIERRE_CJ" ? setVisibleConfirm(true) : saveConfirmacionOPT()} disabled={submitting} />
            </div>);
        }
    }


    if (genericasSistema_FORMULARIO_GENERICO_INTENTO !== null && genericasSistema_FORMULARIO_GENERICO_INTENTO.length > 0
        && genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO !== null
        && genericasSistema_FORMULARIO_GENERICO_NOTAPADRE !== null
        //&& genericasSistema_FORMULARIO_GENERICO_DETALLE !== null
    ) {

        console.log("hola", genericasSistema_FORMULARIO_GENERICO_NOTAPADRE);

    }
    console.log("genericasSistema_FORMULARIO_GENERICO_INTENTO", genericasSistema_FORMULARIO_GENERICO_INTENTO,
        "genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO", genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO,
        "genericasSistema_FORMULARIO_GENERICO_NOTAPADRE", genericasSistema_FORMULARIO_GENERICO_NOTAPADRE,
        //"genericasSistema_FORMULARIO_GENERICO_DETALLE", genericasSistema_FORMULARIO_GENERICO_DETALLE,
    );

    let NoRequiereNiEsperaOPT = !(requiereConfirmacionOPT && esperandoConfirmacionOPT);

    //if (!genericaSistemaDialog || etiquetasModulo.length === 0)
    if (genericaSistemaDialog === false) {
        return (<></>);
    }

    else if (genericaSistemaDialog === true &&
        (etiquetasModulo.length === 0
            || selectedTipoGenerica === undefined
            || selectedTipoGenerica.operaciones === undefined
            || (selectedTipoGenerica.tg !== "BPM_VSTA_SOLICITUD_CD_INVITADO_VERIFICACION_PAGARE")
            || selectedTipoGenerica_FORMULARIO_GENERICO_INTENTO === undefined
            || selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO === undefined
            || selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE === undefined
            || selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE === undefined
            || genericasSistema_FORMULARIO_GENERICO_INTENTO === null
            || genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO === null
            || genericasSistema_FORMULARIO_GENERICO_NOTAPADRE === null
            //|| genericasSistema_FORMULARIO_GENERICO_DETALLE === null
            //|| genericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA === null
            //|| selectedColumns.length === 0
        )
        //|| metadataGenericaSistemaTgOperaciones.length === 0 || genericaSistema === undefined

    ) {
        return (<div>
            <Toast ref={toast} />
            <Dialog id="dialogGenericaSistemaForm" maximizable ref={genericaSistemaDialogRef}
                visible={genericaSistemaDialog} style={{ width: '95%' }}
                header={GetTextoEtiqueta("DIALOG_HEADER_TEXT") + " "} modal className="p-fluid"
                footer={(genericaSistemaDialogFooter())}
                onHide={props.onHideForm} closable={props.onHideForm !== undefined}
            >

                Buscando y cargando formato diligenciado... <ProgressSpinner style={{ width: '15px', height: '15px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />

            </Dialog>
        </div>);

    }

    else if (genericaSistemaDialog === true &&
        (etiquetasModulo.length === 0
            || selectedTipoGenerica === undefined || selectedTipoGenerica.operaciones === undefined
            || (selectedTipoGenerica.tg !== "BPM_VSTA_SOLICITUD_CD_INVITADO_VERIFICACION_PAGARE")
            || selectedTipoGenerica_FORMULARIO_GENERICO_INTENTO === undefined
            || selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO === undefined
            || selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE === undefined
            || selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE === undefined
            || genericasSistema_FORMULARIO_GENERICO_INTENTO === null
            || genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO === null
            || genericasSistema_FORMULARIO_GENERICO_NOTAPADRE === null
            //|| genericasSistema_FORMULARIO_GENERICO_DETALLE === null
            //|| genericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA === null
            //|| selectedColumns.length === 0
            || metadataGenericaSistemaTgOperaciones.length === 0 || genericaSistema === undefined
            || (editando === false && loadingLazyData === false)

        )

    ) {
        let y = "";
        return (<div>
            <Toast ref={toast} />
            <Dialog id="dialogGenericaSistemaForm" maximizable ref={genericaSistemaDialogRef}
                visible={genericaSistemaDialog} style={{ width: '95%' }}
                header={GetTextoEtiqueta("DIALOG_HEADER_TEXT") + " " + selectedTipoGenerica.ctiTexto} modal className="p-fluid"
                footer={(genericaSistemaDialogFooter())}
                onHide={props.onHideForm} closable={props.onHideForm !== undefined}
            >

                Aún no ha diligenciado el formato

                <FormularioFacturaHeader></FormularioFacturaHeader>

            </Dialog>
        </div>);
    }

    else if (genericaSistemaDialog === true &&
        (etiquetasModulo.length === 0
            || selectedTipoGenerica === undefined || selectedTipoGenerica.operaciones === undefined
            || (selectedTipoGenerica.tg !== "BPM_VSTA_SOLICITUD_CD_INVITADO_VERIFICACION_PAGARE")
            || selectedTipoGenerica_FORMULARIO_GENERICO_INTENTO === undefined
            || selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO === undefined
            || selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE === undefined
            || selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE === undefined
            || genericasSistema_FORMULARIO_GENERICO_INTENTO === null
            || genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO === null
            || genericasSistema_FORMULARIO_GENERICO_NOTAPADRE === null
            || genericasSistema_FORMULARIO_GENERICO_DETALLE === null
            //|| genericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA === null
            //|| selectedColumns.length === 0
            || metadataGenericaSistemaTgOperaciones.length === 0 || genericaSistema === undefined
            || genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO.length === 0
            || genericasSistema_FORMULARIO_GENERICO_NOTAPADRE.length === 0
            //|| genericasSistema_FORMULARIO_GENERICO_DETALLE.length === 0
            //|| (validarOptionsSelectButtonRef.current === true && genericasSistema_FORMULARIO_PREGUNTA_RESPUESTA_REFERENCIADA.length === 0)
            || (editando === true && loadingLazyData === true)
        )

    ) {
        if (selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE !== null && selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE.length > 0) {
            console.log("hola");
        }

        let texto = "Cargando datos";

        if (creandoFormulario) {
            texto = "Creando Formulario";
        }

        return (<div>
            <Toast ref={toast} />
            <Dialog id="dialogGenericaSistemaForm" maximizable ref={genericaSistemaDialogRef}
                visible={genericaSistemaDialog} style={{ width: '95%' }}
                header={GetTextoEtiqueta("DIALOG_HEADER_TEXT") + " " + selectedTipoGenerica.ctiTexto} modal className="p-fluid"
                footer={(genericaSistemaDialogFooter())}
                onHide={props.onHideForm} closable={props.onHideForm !== undefined}
            >

                {texto}

                <ProgressSpinner style={{ width: '15px', height: '15px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />

            </Dialog>
        </div>);


    }

    else if (!modoEdicion)
        //console.log("selectedTipoGenerica, ", selectedTipoGenerica);
        //console.log("metadataGenericaSistemaForm, ", metadataGenericaSistemaForm);
        return (
            <div>
                <Toast ref={toast} />

                <Dialog id="dialogGenericaSistemaForm" maximizable ref={genericaSistemaDialogRef}
                    visible={genericaSistemaDialog} style={{ width: '95%' }}
                    header={GetTextoEtiqueta("DIALOG_HEADER_TEXT") + " " + genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO[0].uts['ctiTextoformato']} modal className="p-fluid"
                    footer={(genericaSistemaDialogFooter())}
                    onHide={props.onHideForm} closable={props.onHideForm !== undefined}
                >

                    <FormularioFacturaHeader></FormularioFacturaHeader>

                    {generarCabeceraFormulario()}



                </Dialog>
            </div>
        );//{generarSegmentosFormularioGenericaSistemaSeleccionada()}
    /*
    
    <DataTableGenericaPreguntaFormato canEditRow={false} selectedTipoGenerica={selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE}
                        onSelectedItem={onSelectedItem} onChangeDataInterno={onChangeDataInterno}
                        metadataRef={metadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE}
                        //metadataRef={metadataGenericaSistemaForm}
                        genericasSistema={genericasSistema_FORMULARIO_GENERICO_DETALLE}
                        camposAMostrar={camposAMostrar_FORMULARIO_GENERICO_DETALLE}
                        onSaveSuccessfull={onSaveSuccessfullDataTableGenericaCalificacion}
                    
    
                    </DataTableGenericaPreguntaFormato>
     <DataTableListGenericaRaw selectedTipoGenerica={selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE}
                            //onSelectedItem={onSelectedItem} 
                            //onChangeDataInterno={onChangeDataInterno} 
                            metadataRef={metadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE}
                            genericasSistema={genericasSistema_FORMULARIO_GENERICO_DETALLE}
                            camposAMostrar={camposAMostrar_FORMULARIO_GENERICO_DETALLE}
                        >
     
                        </DataTableListGenericaRaw>
    */


    else if (NoRequiereNiEsperaOPT && utilizaDialog) {

        return (
            <div>
                <Toast ref={toast} />
                <ConfirmDialog />

                <Dialog id="dialogGenericaSistemaForm" ref={genericaSistemaDialogRef}
                    visible={genericaSistemaDialog}
                    style={{ width: '99%' }} resizable={false} position='top'
                    header={GetTextoEtiqueta("DIALOG_HEADER_TEXT") + " " + genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO[0].uts['ctiTextoformato']} modal className="p-fluid"
                    footer={genericaSistemaDialogFooter()}
                    onHide={props.onHideForm ? props.onHideForm : undefined}
                    closable={props.onHideForm !== undefined}
                //closable={false}
                >
                    <div className="marcoFormulario">
                        <FormularioFacturaHeader></FormularioFacturaHeader>

                        {generarCamposFormularioGenericaSistemaSeleccionada()}


                    </div>

                </Dialog>
            </div>
        );
    }

    else if (NoRequiereNiEsperaOPT && !utilizaDialog) {

        return (
            <div>
                <Toast ref={toast} />
                <ConfirmDialog />

                <div className="marcoFormulario">
                    <FormularioFacturaHeader></FormularioFacturaHeader>

                    {generarCamposFormularioGenericaSistemaSeleccionada()}


                </div>
            </div>
        );
    }

    //A continuación para la verificación del OPT del segundo paso.
    else if (!NoRequiereNiEsperaOPT && utilizaDialog) {

        return (
            <div>
                <Toast ref={toast} />
                <ConfirmDialog />

                <Dialog id="dialogGenericaSistemaForm"
                    maximizable ref={genericaSistemaDialogRef} visible={genericaSistemaDialog}
                    style={{ width: '95%' }} header={GetTextoEtiqueta("DIALOG_HEADER_TEXT") + " " + selectedTipoGenerica.ctiTexto}
                    modal className="p-fluid" footer={confirmacionOPTFooter} onHide={props.onHideForm}>

                    {generarCamposConfirmacionOPT()}



                </Dialog>
            </div>
        )
    }
    else {

        return (
            <div className='grid'>
                <Toast ref={toast} />
                <ConfirmDialog />

                {generarCamposConfirmacionOPT()}

                {confirmacionOPTFooter()}

            </div>
        )
    }



});

export default FormularioCalculadoraCredito;
